import image_logoDark from '../assets/logo-dark.png'
import image_7a56548a0dbf182ef28c570bcae1ce3c84f6df58 from '../assets/7a56548a0dbf182ef28c570bcae1ce3c84f6df58.png'
import image_5a245c50f336d46376d729454405429f3ad8f4fe from '../assets/5a245c50f336d46376d729454405429f3ad8f4fe.png'
import logoDisplay from '../assets/ea7ac5e850d5017cf0b00a4ae0d815b6234968f9.png'
import logoShare from '../assets/3d148a3768883c8332d6b839efffabb270a7bdd0.png'
import logoAnycast from '../assets/b43367377fae0b25870490d9aa93215f57c2b078.png'
import logoMail from '../assets/f9323caf1e6d031d8e1c6dcb8745884bc609a8ef.png'
import logoLink from '../assets/9570cf40648af9e37690a28cbe70bad116548ba1.png'
import logoMailbox from '../assets/4aa63bcae1cd23ec423b8086bfb86e0ce04d4da6.png'
import logoFooterIcon from '../assets/fe560d13a4f08be4e761d181886a16cf58473a48.png'
import logoGoldenCreative from '../assets/24f641161a013b22ba837688a05875d8a759d5d6.png'
import { isLikelySwiftWooJwt, getSwiftWooJwt } from './lib/jwt';
import { getStoreCapabilities, isNativeStore, capabilityAvailable as capabilityAvailableForNav } from './lib/storeConnections';
import { getStoreSubdomainSlug, isMasterHost } from './lib/storeDomain';
import React, { useState, useEffect, useCallback, Suspense, lazy } from "react";
import {
  Users,
  LayoutDashboard,
  ShoppingBag,
  Layers,
  Package,
  Settings,
  User,
  LogOut,
  Bell,
  Search,
  Menu,
  X,
  ClipboardList,
  Image as ImageIcon,
  Tag,
  Globe,
  Sun,
  Moon,
  ScrollText,
  Gift,
  Mail,
  Lock,
  Eye,
  EyeOff,
  Shield,
  ArrowRight,
  ArrowLeft,
  RefreshCw,
  Loader2,
  PhoneCall,
  Landmark
} from "lucide-react";
import { useBrand } from "./store/BrandContext";
import { updateStoreManifest } from "./lib/pwaManifest";

import { Button } from "./components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "./components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "./components/ui/dropdown-menu";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./components/ui/select";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  CardFooter
} from "./components/ui/card";
const WooCommerceDashboard = lazy(() => import("./components/woocommerce-dashboard").then(m => ({ default: m.WooCommerceDashboard })));
const WooCommerceProducts = lazy(() => import("./components/woocommerce-products").then(m => ({ default: m.WooCommerceProducts })));
const WooCommerceGallery = lazy(() => import("./components/woocommerce-gallery").then(m => ({ default: m.WooCommerceGallery })));
const WooCommerceBrands = lazy(() => import("./components/woocommerce-brands").then(m => ({ default: m.WooCommerceBrands })));
const WooCommerceCategories = lazy(() => import("./components/woocommerce-categories").then(m => ({ default: m.WooCommerceCategories })));
const WooCommerceLoyalty = lazy(() => import("./components/woocommerce-loyalty").then(m => ({ default: m.WooCommerceLoyalty })));
const WooCommerceOrders = lazy(() => import("./components/woocommerce-orders").then(m => ({ default: m.WooCommerceOrders })));
const WooCommerceStock = lazy(() => import("./components/woocommerce-stock").then(m => ({ default: m.WooCommerceStock })));
const WooCommerceCustomers = lazy(() => import("./components/woocommerce-customers").then(m => ({ default: m.WooCommerceCustomers })));
const WooCommerceSettings = lazy(() => import("./components/woocommerce-settings").then(m => ({ default: m.WooCommerceSettings })));
const WooCommerceProfile = lazy(() => import("./components/woocommerce-profile").then(m => ({ default: m.WooCommerceProfile })));
const WooCommerceLeads = lazy(() => import("./components/woocommerce-leads").then(m => ({ default: m.WooCommerceLeads })));
const PosTerminal = lazy(() => import("./components/pos-terminal").then(m => ({ default: m.PosTerminal })));
const ClientLayout = lazy(() => import("./components/client/ClientLayout"));
const PricingLandingPage = lazy(() => import("./components/PricingLandingPage"));
const MasterPlans = lazy(() => import("./components/master/MasterPlans").then(m => ({ default: m.MasterPlans })));
const MasterSubscriptions = lazy(() => import("./components/master/MasterSubscriptions").then(m => ({ default: m.MasterSubscriptions })));
const MasterFinancial = lazy(() => import("./components/master/MasterFinancial").then(m => ({ default: m.MasterFinancial })));
const ManagerSubscription = lazy(() => import("./components/manager/ManagerSubscription").then(m => ({ default: m.ManagerSubscription })));
const LogsTab = lazy(() => import("./components/logs-tab").then(m => ({ default: m.LogsTab })));
const Notificacoes = lazy(() => import("./pages/Notificacoes").then(m => ({ default: m.Notificacoes })));
import { addAppLog } from "./lib/logger";
import { Download, Share, Smartphone, WifiOff, QrCode, CreditCard } from "lucide-react";
import { PullToRefresh } from "./components/pull-to-refresh";
import { motion, AnimatePresence } from "motion/react";
import { toast } from "sonner";
import { Input } from "./components/ui/input";
import { Label } from "./components/ui/label";
import { Badge } from "./components/ui/badge";
import { WooCommerceAPI, loadConfig, saveConfig, projectId, getServerUrl, publicAnonKey, loadKVFromServer, loadConfigFromServer, clientAuth, parseAgentEmbed } from "./lib/woocommerce";
import { supabase } from './lib/woocommerce';
import { SyncService } from "./lib/sync-service";
import { useNativePush } from './hooks/useNativePush';
import { db } from "./lib/db";
import { Toaster } from "./components/ui/sonner";

// PWAMeta removed to allow dynamic manifest from main.tsx
import { PluginApiClient } from "./lib/pluginApiClient";

// Assets
import logoFullLight from "../assets/logo-light.png";
import logoFullDark from "../assets/logo-dark.png";
import logoSquare from "../assets/23c57471fbe4cd57ae7a7296635e838d6ae9d447.png";
import mobileLogo from "../assets/fe560d13a4f08be4e761d181886a16cf58473a48.png";

type View = "dashboard" | "products" | "gallery" | "brands" | "categories" | "orders" | "customers" | "stock" | "logs" | "settings" | "account" | "loyalty" | "pos_products" | "pos_customers" | "pos_scanner" | "leads" | "notificacoes" | "master_plans" | "master_subscriptions" | "master_finance" | "manager_subscription";

export default function App() {
  const [currentView, setCurrentView] = useState<View>(() => {
    const isMasterAdmin = localStorage.getItem('is_master_admin') === 'true';
    if (isMasterAdmin) return 'dashboard';
    return localStorage.getItem('app_user_role') === 'pos' ? 'pos_products' : 'dashboard';
  });
  const [showPWAInvite, setShowPWAInvite] = useState(false);
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [isSyncing, setIsSyncing] = useState(false);
  const { subscribeToPush } = useNativePush();

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      toast.success("Ligação restabelecida. A sincronizar dados...");
      window.dispatchEvent(new CustomEvent('force-products-sync'));
    };
    const handleOffline = () => {
      setIsOffline(true);
      toast.warning("Está offline. A usar dados guardados localmente.", { duration: 5000 });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    // Check if on mobile and not already in standalone mode
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isStandalone = (window.navigator as any).standalone || window.matchMedia('(display-mode: standalone)').matches;

    // Only show if mobile, not standalone, and haven't dismissed it in this session
    if (isMobile && !isStandalone && !sessionStorage.getItem('pwa_invite_dismissed')) {
      const timer = setTimeout(() => setShowPWAInvite(true), 3000);
      return () => clearTimeout(timer);
    }
  }, []);
  useEffect(() => {
    // Global fix for brand images with malformed URLs (.webp, -> .webp?)
    const fixBrandImages = () => {
      const images = document.querySelectorAll('img');
      images.forEach(img => {
        if (img.src) {
          if (img.src.includes('.webp,')) {
            img.src = img.src.replace('.webp,', '.webp?');
          }
          if (img.src.includes('.png,')) {
            img.src = img.src.replace('.png,', '.png?');
          }
          if (img.src.includes('.jpg,')) {
            img.src = img.src.replace('.jpg,', '.jpg?');
          }
          if (img.src.includes('.jpeg,')) {
            img.src = img.src.replace('.jpeg,', '.jpeg?');
          }
        }
      });
    };

    const observer = new MutationObserver(() => {
      fixBrandImages();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    fixBrandImages();
    return () => observer.disconnect();
  }, []);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [userName, setUserName] = useState("John Doe");
  const [notifications, setNotifications] = useState<any[]>([]);
  const [pendingOrdersCount, setPendingOrdersCount] = useState<number>(0);
  const [showPassword, setShowPassword] = useState(false);
  const { brandConfig, brandColor, logoUrl, storeName } = useBrand();

  useEffect(() => {
    if (brandConfig?.url) {
      localStorage.setItem('wc_app_domain', brandConfig.url);
    }
  }, [brandConfig]);

  const [isDarkMode, setIsDarkMode] = useState(() => {
    if (typeof window === 'undefined') return true;
    if (brandConfig && brandConfig.theme_mode === 'light') {
      return false;
    }
    const theme = localStorage.getItem('theme');
    return theme ? theme === 'dark' : true;
  });

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        // Register sw.js which now includes OneSignal support
        navigator.serviceWorker.register('/sw.js', { scope: '/' })
          .then(reg => {
            console.log('SW registered with scope:', reg.scope);

            // Check for a new service worker when the app regains focus —
            // installed PWAs otherwise keep running stale code until the
            // user deletes and re-adds the app to the home screen.
            document.addEventListener('visibilitychange', () => {
              if (document.visibilityState === 'visible') reg.update().catch(() => {});
            });
            reg.addEventListener('updatefound', () => {
              const worker = reg.installing;
              if (!worker) return;
              worker.addEventListener('statechange', () => {
                if (worker.state === 'installed' && navigator.serviceWorker.controller) {
                  toast.info('Nova versão disponível. A atualizar a app…', { duration: 3000 });
                }
              });
            });
          })
          .catch(err => console.log('SW registration failed:', err));

        // Once the new worker takes control, reload once to pick up the
        // fresh build (navigations are network-first, so this is safe).
        // Loop guard: if updates keep rolling in (e.g. a flaky SW source),
        // never reload more than once per 60s — the sessionStorage flag
        // survives reloads and breaks the cycle for good.
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          const last = parseInt(sessionStorage.getItem('sw_controller_reload') || '0', 10);
          if (Date.now() - last < 60_000) return;
          sessionStorage.setItem('sw_controller_reload', String(Date.now()));
          window.location.reload();
        });
      });
    }

    // Initialize OneSignal V16 using OneSignalDeferred pattern
    const initOneSignal = async () => {
      try {
        // Push needs a secure context — any HTTPS origin works (covers
        // lojapilot.pt and every store custom domain). Unregistered
        // origins are rejected server-side by the OneSignal app config,
        // so no local allowlist is needed.
        const currentHostname = window.location.hostname;
        const isSecureContext =
          window.location.protocol === 'https:' ||
          ['localhost', '127.0.0.1'].includes(currentHostname);

        if (!isSecureContext) {
          console.log(`[OneSignal] Skipping initialization - insecure origin ${currentHostname}`);
          addAppLog('info', 'OneSignal', `Skipped initialization on ${currentHostname} (insecure origin)`);
          return;
        }

        const windowObj = (window as any);
        const brandConfig = windowObj.__brandConfig || {};

        // Inject Script tag for OneSignal V16
        if (!document.getElementById('onesignal-sdk')) {
          const script = document.createElement('script');
          script.id = 'onesignal-sdk';
          script.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
          script.defer = true;
          document.head.appendChild(script);
        }

        windowObj.OneSignalDeferred = windowObj.OneSignalDeferred || [];
        windowObj.OneSignalDeferred.push(async function (OneSignal: any) {
          if (OneSignal.initialized) {
            console.log("[OneSignal] Already initialized, skipping.");
            return;
          }

          try {
            await OneSignal.init({
              appId: brandConfig.onesignal_app_id || "84875f92-e96e-4bc8-9325-ded383b066cb",
              safari_web_id: brandConfig.onesignal_safari_id || "web.onesignal.auto.1bb493cc-6f2b-4253-90e1-02d85a4b9e78",
              notifyButton: { enable: false },
              allowLocalhostAsSecureOrigin: true,
              // Merge into OUR service worker instead of registering a second
              // worker (OneSignalSDKWorker.js) at scope '/'. Two SWs fighting
              // for the same scope ping-pong controllerchange → reload loop.
              // sw.js already importScripts the OneSignal SDK, so it serves
              // both push + PWA caching under one registration.
              serviceWorkerPath: 'sw.js',
              serviceWorkerParam: { scope: '/' },
            });
            console.log("[OneSignal] V16 initialized successfully");
            addAppLog('success', 'OneSignal', 'V16 initialization queued successfully');
          } catch (e: any) {
            if (e.message?.includes('already initialized')) {
              console.log("[OneSignal] Was already initialized.");
            } else if (e.message?.includes('Can only be used on')) {
              console.warn("[OneSignal] Domain restriction:", e.message);
            } else {
              console.error("[OneSignal] Initialization error:", e);
            }
          }
        });
      } catch (err: any) {
        console.error('[OneSignal] Catastrophic failure during initialization:', err);
        addAppLog('error', 'OneSignal', `Initialization blocked: ${err.message}`);
      }
    };

    // Expor função globalmente para ser chamada APÓS o login
    (window as any).__initOneSignal = async (userId: string, role: string = 'client') => {
      await initOneSignal();
      if (userId) {
        const windowObj = window as any;
        windowObj.OneSignalDeferred = windowObj.OneSignalDeferred || [];
        windowObj.OneSignalDeferred.push(async function (OneSignal: any) {
          if (userId && String(userId).trim() !== '' && String(userId) !== 'undefined') {
            try {
              await OneSignal.login(String(userId));

              const slug = localStorage.getItem('pwa_store_slug') || 'default';
              if (OneSignal.User && OneSignal.User.addTags) {
                OneSignal.User.addTags({
                  store_id: slug,
                  role: role
                });
              }

              console.log(`[OneSignal] Sincronizado com utilizador: ${userId} na loja: ${slug}`);
            } catch (e) {
              console.warn('[OneSignal] Error during login/addTags:', e);
            }
          }
        });
      }
    };

    // Auto-init APENAS se já houver uma sessão ativa (Staff ou Cliente)
    const isAppLoggedIn = localStorage.getItem('app_logged_in') === 'true';
    if (isAppLoggedIn) {
      const activeId = localStorage.getItem('wc_active_store_id') || 'default';
      const clientId = localStorage.getItem(`client_id_${activeId}`);
      if (clientId) {
        (window as any).__initOneSignal(clientId);
      } else {
        const appUsername = localStorage.getItem('app_username');
        if (appUsername) (window as any).__initOneSignal(appUsername, 'staff');
      }
    }

  }, []);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      document.documentElement.classList.add('light');
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  // Removido o pedido de permissão genérico no onMount para evitar spam precoce


  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

  const [lastOrderCheck, setLastOrderCheck] = useState<number>(() => {
    const saved = localStorage.getItem('last_order_check_ts');
    // Default to 48 hours ago to ensure we catch recent orders on first load
    return saved ? parseInt(saved) : Date.now() - (48 * 60 * 60 * 1000);
  });

  const [multiStore, setMultiStore] = useState<{ id: string, name: string, config: any }[]>(() => {
    const saved = localStorage.getItem('wc_multistore');
    return saved ? JSON.parse(saved) : [];
  });
  const [activeStoreId, setActiveStoreId] = useState<string>(() => {
    return localStorage.getItem('wc_active_store_id') || 'default';
  });
  const [clientAuthenticated, setClientAuthenticated] = useState<boolean>(() => {
    const token = localStorage.getItem(`client_token_${localStorage.getItem('wc_active_store_id') || 'default'}`);
    return !!token;
  });
  const [clientUser, setClientUser] = useState<any>(null);

  const activeStoreConfig = multiStore.find(s => s.id === activeStoreId)?.config || loadConfig() || {};

  const resolveStoreUrl = () => {
    const candidates = [
      brandConfig?.store_url,
      brandConfig?.url,
      (window as any).__brandConfig?.store_url,
      (window as any).__brandConfig?.url,
      localStorage.getItem('wc_active_store_url'),
      activeStoreConfig?.url,
      multiStore.find(s => s.id === activeStoreId)?.config?.url,
      loadConfig()?.url,
    ];
    const value = candidates.find((candidate): candidate is string => !!candidate && typeof candidate === 'string' && candidate.trim().length > 0);
    if (value) {
      localStorage.setItem('wc_active_store_url', value);
    }
    return value || null;
  };

  useEffect(() => {
    if (brandConfig?.store_id && brandConfig.store_id !== activeStoreId) {
      setActiveStoreId(brandConfig.store_id);
      localStorage.setItem('wc_active_store_id', brandConfig.store_id);
      localStorage.setItem('wcactivestoreid', brandConfig.store_id);
    }
  }, [brandConfig?.store_id, activeStoreId]);

  const hasClientLoginTarget = Boolean(resolveStoreUrl());

  useEffect(() => {
    const syncClientAuthState = async () => {
      const storeId = localStorage.getItem('wc_active_store_id') || 'default';
      const config = loadConfig();
      const token = clientAuth.getToken(storeId);

      if (!config || !token) {
        setClientAuthenticated(false);
        setClientUser(null);
        return;
      }

      const isValid = await clientAuth.validateToken(config, storeId);
      if (!isValid) {
        clientAuth.logout(storeId);
        setClientAuthenticated(false);
        setClientUser(null);
        return;
      }

      const me = await clientAuth.getMe(config, storeId);
      const nextUser = me || clientAuth.getUser(storeId);
      setClientUser(nextUser);
      setClientAuthenticated(true);
    };

    syncClientAuthState();
  }, [activeStoreId]);

  useEffect(() => {
    const onClientLoggedIn = (event: Event) => {
      const detail = (event as CustomEvent).detail || {};
      const storeId = detail.storeId || activeStoreId;
      const nextUser = clientAuth.getUser(storeId) || detail.user || null;
      setClientUser(nextUser);
      setClientAuthenticated(true);
    };

    const onClientLoggedOut = () => {
      setClientAuthenticated(false);
      setClientUser(null);
    };

    window.addEventListener('client-logged-in', onClientLoggedIn);
    window.addEventListener('client-logged-out', onClientLoggedOut);

    return () => {
      window.removeEventListener('client-logged-in', onClientLoggedIn);
      window.removeEventListener('client-logged-out', onClientLoggedOut);
    };
  }, [activeStoreId]);

  // Export activeStoreId to window for components to track state changes
  useEffect(() => {
    (window as any).__activeStoreId = activeStoreId;
  }, [activeStoreId]);

  // White-label: slug present in URL (e.g. /cannabis) — computed once on mount
  // /loja/{slug} is the dedicated public storefront route (product catalog,
  // guest checkout). /{slug} remains the store app (login / manager).
  const __pathParts = window.location.pathname.split('/').filter(Boolean);
  const isStorefrontPath = __pathParts[0]?.toLowerCase() === 'loja';
  // The store slug can come from the path (/{slug}, /loja/{slug}) or from a
  // store subdomain ({slug}.lojapilot.pt) where the path has no slug.
  const urlStoreSlug = (isStorefrontPath ? __pathParts[1] : __pathParts[0])?.toLowerCase() || getStoreSubdomainSlug(window.location.hostname) || '';
  // Store resolved purely from the URL slug (/loja/{slug} or /{slug}) — never
  // relies on the staff session's local multistore list, so the public
  // storefront renders even when staff is logged into another store or the
  // cached wc_multistore is stale.
  const [urlStore, setUrlStore] = useState<{ id: string, name: string, config: any } | null>(null);

  const handleSwitchStore = async (storeId: string) => {
    // Check if user is allowed to access this store
    const isMaster = localStorage.getItem('is_master_admin') === 'true';
    const allowedStores = JSON.parse(localStorage.getItem('allowed_stores') || "[]");

    if (!isMaster && allowedStores.length > 0 && !allowedStores.includes(storeId)) {
      toast.error("Não tem permissões para aceder a esta loja.");
      return;
    }

    const store = multiStore.find(s => s.id === storeId);
    if (!store) {
      toast.error('Loja não encontrada.');
      return;
    }

    const oldStoreId = activeStoreId;

    // 1. DO NOT clear old store cache - preserve it for offline-first fast switching!

    // 2. Set new store
    setActiveStoreId(storeId);
    localStorage.setItem('wc_active_store_id', storeId);
    localStorage.setItem('wcactivestoreid', storeId);

    saveConfig(store.config);
    toast.success(`Mudou para ${store.name}`);

    // Check if cache exists for the new store

    const cachedProducts = await db.products.where('storeId').equals(storeId).count();
    const hasCache = cachedProducts > 0;

    // Force content refresh by notifying components immediately (before sync)
    // so they can render from cache if available.
    window.dispatchEvent(new Event('storage'));
    window.dispatchEvent(new CustomEvent('config-updated', { detail: store.config }));
    window.dispatchEvent(new CustomEvent('store-switched', { detail: storeId }));

    // 3. Sync Strategy (SWR)
    if (hasCache) {
      console.log(`[App] Cache found for store ${storeId}. Doing silent background sync.`);
      // Do silent sync
      SyncService.preloadAllTabs(storeId).catch(err => {
        console.error("Background switch preload failed", err);
      });
    } else {
      console.log(`[App] No cache for store ${storeId}. Doing blocking sync.`);
      setIsSyncing(true);
      try {
        await SyncService.preloadAllTabs(storeId);
      } catch (err) {
        console.error("Switch preload failed", err);
      } finally {
        setIsSyncing(false);
      }
    }
  };

  const [readNotifications, setReadNotifications] = useState<string[]>(() => {
    const saved = localStorage.getItem('read_notifications');
    return saved ? JSON.parse(saved) : [];
  });

  const markAsRead = (id: string) => {
    setReadNotifications(prev => {
      const next = [...new Set([...prev, id])];
      localStorage.setItem('read_notifications', JSON.stringify(next));
      return next;
    });
  };

  const fetchNotifications = useCallback(async () => {
    // Order notifications are a staff feature — never poll orders or fire
    // notifications for guest/client visitors, even if store credentials
    // linger in localStorage from a previous staff session.
    if (localStorage.getItem('app_logged_in') !== 'true') return;
    // Skip if syncing or config missing
    if (isSyncing) return;

    const config = loadConfig();
    // Native stores have no Woo credentials — push init still applies.
    if (config?.connectionType !== 'native' && (!config?.url || !config?.consumerKey || !config?.consumerSecret)) return;

    // Check Push Notification status
    if ('Notification' in window && Notification.permission === 'default' && localStorage.getItem('app_logged_in') === 'true') {
      Notification.requestPermission();
    }

    try {
      const activeId = localStorage.getItem('wc_active_store_id') || 'default';
      const orders = await WooCommerceAPI.getOrders(config, {
        per_page: 20,
        status: 'any',
        isNotification: true
      });

      if (Array.isArray(orders)) {
        // Update total pending count
        const pendingCount = orders.filter(o => o.status === 'processing' || o.status === 'pending' || o.status === 'on-hold').length;
        setPendingOrdersCount(pendingCount);

        // Find orders newer than our last check OR just recent orders (last 48h)
        const recentOrders = orders.filter(o => {
          if (!o.date_created) return false;
          const orderDate = new Date(o.date_created).getTime();
          // Show orders from last 48 hours in the list
          return orderDate > (Date.now() - (48 * 60 * 60 * 1000));
        });

        const newNotifications = recentOrders.map(o => ({
          id: `order-${activeId}-${o.id}`,
          title: "New Order",
          message: `Order #${o.id} - ${o.billing?.first_name || 'Customer'} (${o.total} ${o.currency})`,
          time: new Date(o.date_created).toLocaleString(),
          type: "order",
          status: o.status,
          isNew: new Date(o.date_created).getTime() > lastOrderCheck,
          storeId: activeId
        }));

        setNotifications(newNotifications.sort((a, b) => b.isNew ? 1 : -1).slice(0, 15));

        // Browser Push Notification for TRULY new ones
        const trulyNewOnes = orders.filter(o => {
          if (!o.date_created) return false;
          return new Date(o.date_created).getTime() > lastOrderCheck;
        });

        if (trulyNewOnes.length > 0) {
          const latestOrder = trulyNewOnes[0];
          if ('Notification' in window && Notification.permission === 'granted') {
            const notifSlug = localStorage.getItem('pwa_store_slug') || '';
            const sbUrl = (import.meta.env.VITE_SUPABASE_URL || '').replace(/\/+$/, '');
            new Notification("Nova Encomenda Recebida", {
              body: `Encomenda #${latestOrder.id} of ${latestOrder.total} ${latestOrder.currency}`,
              icon: notifSlug && sbUrl
                ? `${sbUrl}/functions/v1/make-server-75caf0c1/icon/${encodeURIComponent(notifSlug)}/192`
                : '/brand/lojapilot-app-icon.png'
            });
          }

          const newTs = Date.now();
          setLastOrderCheck(newTs);
          localStorage.setItem('last_order_check_ts', newTs.toString());
          toast.success(`Nova Encomenda: #${latestOrder.id}`);
          addAppLog('success', 'Encomenda Criada', `Encomenda #${latestOrder.id} criada`);
        }
      }
    } catch (e) {
      console.error("Notification fetch error", e);
    }
  }, [lastOrderCheck]);

  const [userAvatar, setUserAvatar] = useState<string | null>(null);

  const fetchProfileLocal = useCallback(() => {
    const username = localStorage.getItem('app_username') || "admin";
    const first = localStorage.getItem(`user_first_name_${username}`) || (localStorage.getItem('is_master_admin') === 'true' ? "Master" : "Store");
    const last = localStorage.getItem(`user_last_name_${username}`) || (localStorage.getItem('is_master_admin') === 'true' ? "Admin" : "Manager");
    const avatar = localStorage.getItem(`user_avatar_${username}`);
    setUserName(`${first} ${last}`);
    setUserAvatar(avatar || null);

    // Update multistore list from storage too
    const savedStores = localStorage.getItem('wc_multistore');
    if (savedStores) setMultiStore(JSON.parse(savedStores));
    const savedActive = localStorage.getItem('wc_active_store_id');
    if (savedActive) setActiveStoreId(savedActive);
  }, []);

  useEffect(() => {
    fetchProfileLocal();

    const handleProfileUpdate = () => {
      fetchProfileLocal();
    };
    window.addEventListener('profile-updated', handleProfileUpdate);
    window.addEventListener('storage', fetchProfileLocal);

    fetchNotifications();
    const interval = setInterval(() => {
      const isAutoSyncEnabled = localStorage.getItem('wc_auto_sync') !== 'false';
      if (isAutoSyncEnabled) {
        fetchNotifications();
      }
    }, 180000); // Increased to 3 minutes to reduce server load

    return () => {
      window.removeEventListener('profile-updated', handleProfileUpdate);
      window.removeEventListener('storage', fetchProfileLocal);
      clearInterval(interval);
    };
  }, [fetchProfileLocal, fetchNotifications]);

  useEffect(() => {
    const handleViewChange = (e: any) => {
      if (e.detail) {
        setCurrentView(e.detail as View);
      }
    };
    window.addEventListener('change-view', handleViewChange);
    return () => window.removeEventListener('change-view', handleViewChange);
  }, []);

  // LojaPilot capability model: hide tabs a store connection type can't serve.
  const storeCaps = getStoreCapabilities(activeStoreConfig);
  const capabilityHiddenTabs: string[] = [
    ...(isNativeStore(activeStoreConfig) ? ['gallery'] : []), // wp/v2 media library doesn't exist natively
    ...(!capabilityAvailableForNav(storeCaps.brands) ? ['brands'] : []),
    ...(!capabilityAvailableForNav(storeCaps.loyalty) ? ['loyalty'] : []),
    ...(!capabilityAvailableForNav(storeCaps.reports) ? [] : []),
  ];
  const hiddenTabsMaster = [...(activeStoreConfig.hiddenTabs || []), ...capabilityHiddenTabs];
  const hiddenTabsManager = [...(activeStoreConfig.hiddenTabsManager || activeStoreConfig.hiddenTabs || []), ...capabilityHiddenTabs];


  const rawNavItems = [
    { id: "dashboard", label: "Início", icon: LayoutDashboard },
    { id: "products", label: "Produtos", icon: ShoppingBag },
    { id: "pos_products", label: "Produtos", icon: ShoppingBag },
    { id: "gallery", label: "Galeria", icon: ImageIcon },
    { id: "brands", label: "Marcas", icon: Tag },
    { id: "categories", label: "Categorias", icon: Layers },
    { id: "orders", label: "Encomendas", icon: ClipboardList },
    { id: "customers", label: "Clientes", icon: Users },
    { id: "stock", label: "Stock", icon: Package },
    { id: "logs", label: "Registos", icon: ScrollText },
    { id: "loyalty", label: "Fidelidade", icon: Gift },
    { id: "leads", label: "Leads", icon: PhoneCall },
    { id: "notificacoes", label: "Notificações", icon: Bell },
    { id: "master_plans", label: "Planos", icon: CreditCard },
    { id: "master_subscriptions", label: "Subscrições", icon: CreditCard },
    { id: "master_finance", label: "Financeiro", icon: Landmark },
    { id: "manager_subscription", label: "Subscrição", icon: CreditCard },
    { id: "settings", label: "Definições", icon: Settings },
  ];

  const isMasterAdmin = localStorage.getItem('is_master_admin') === 'true';
  const appUserRole = localStorage.getItem('app_user_role');

  const navItems = rawNavItems.filter(item => {
    if (appUserRole === 'pos') {
      // POS role can see: their product terminal, orders, stock, and loyalty
      return ['pos_products', 'orders', 'stock', 'loyalty'].includes(item.id);
    }

    if (item.id === 'pos_products') return false;

    // 'notificacoes', 'master_plans', 'master_subscriptions', 'master_finance' are master-only
    if ((item.id === 'notificacoes' || item.id === 'master_plans' || item.id === 'master_subscriptions' || item.id === 'master_finance') && !isMasterAdmin) return false;
    // 'manager_subscription' is manager-only
    if (item.id === 'manager_subscription' && (isMasterAdmin || appUserRole !== 'manager')) return false;

    if (isMasterAdmin) {
      if (hiddenTabsMaster.includes(item.id)) return false;
    } else {
      if (hiddenTabsManager.includes(item.id)) return false;
      if (item.id === 'leads') return false;
      if (item.id === 'settings' && appUserRole !== 'manager') return false;
    }
    return true;
  });

  const rawMobileFooterItems = [
    { id: "dashboard", label: "Início", icon: LayoutDashboard },
    { id: "orders", label: "Encomendas", icon: ClipboardList },
    { id: "products", label: "Produtos", icon: ShoppingBag },
  ];

  const mobileFooterItems = appUserRole === 'pos'
    ? [
      { id: "pos_products", label: "Produtos", icon: ShoppingBag },
      { id: "orders", label: "Encomendas", icon: ClipboardList },
      { id: "stock", label: "Stock", icon: Package },
    ]
    : rawMobileFooterItems.filter(item => {
      if (isMasterAdmin) {
        return !hiddenTabsMaster.includes(item.id);
      }
      return !hiddenTabsManager.includes(item.id);
    });

  useEffect(() => {
    if (appUserRole === 'pos' && !['pos_products', 'orders', 'stock', 'loyalty', 'account'].includes(currentView)) {
      setCurrentView("pos_products");
      return;
    }

    const isHiddenForCurrentRole = isMasterAdmin
      ? hiddenTabsMaster.includes(currentView)
      : hiddenTabsManager.includes(currentView);

    if (isHiddenForCurrentRole) {
      setCurrentView("dashboard");
    }
  }, [currentView, activeStoreId, multiStore, isMasterAdmin, hiddenTabsMaster, hiddenTabsManager, appUserRole]);

  const [loginMode, setLoginMode] = useState<'staff' | 'client'>(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('client') === 'true') return 'client';

    // Root paths enforce staff login — except on store domains (custom
    // domain or store subdomain), where "/" is the store's own front door
    // and client login is default.
    const path = window.location.pathname;
    const onCustomDomain = !isMasterHost(window.location.hostname);
    if (path === '/login' || (path === '/' && !onCustomDomain)) return 'staff';

    const savedMode = localStorage.getItem('app_login_mode');
    if (savedMode) return savedMode as 'staff' | 'client';

    return 'client'; // Default to client for store slugs
  });

  // A store is white-labeled if we resolved a brand config (covers custom
  // domains/subdomains and PWA-remembered slugs, where the slug never shows
  // up in the URL path) or if the path slug matches a known multistore URL.
  const normUrl = (v?: string) => (v || '').replace(/^\/+/, '').toLowerCase();
  // Short label for a store's connection type — shown as a tag next to store
  // names so admins can tell native LojaPilot stores from WooCommerce ones.
  const connTypeTag = (ct?: string) =>
    ct === 'native' ? 'Nativa' : ct === 'woocommerce_plugin' ? 'Woo Plugin' : ct === 'woocommerce_api' ? 'Woo API' : null;
  const isWhiteLabelUrl = brandConfig !== null || (
    urlStoreSlug !== '' && multiStore.some(s => normUrl(s.config?.customUrl) === urlStoreSlug)
  ) || (
    // Custom domain match
    multiStore.some(s => s.config?.customDomain?.toLowerCase() === window.location.hostname.toLowerCase())
  );

  // Per-store client-login switch: master can disable the "Sou Cliente"
  // tab/module for a store (e.g. staff-only internal apps like Candi).
  const loginStore = urlStore || multiStore.find(s =>
    normUrl(s.config?.customUrl) === urlStoreSlug ||
    s.config?.customDomain?.toLowerCase() === window.location.hostname.toLowerCase()
  );
  const clientLoginEnabled =
    (loginStore?.config?.clientLoginEnabled ?? activeStoreConfig?.clientLoginEnabled) !== false;

  // Guest storefront: unauthenticated visitors on a native store URL browse
  // the public catalog (free-plan default template). They can still flip to
  // the login screen to sign in or register.
  const [guestWantsLogin, setGuestWantsLogin] = useState(false);

  useEffect(() => {
    if (!clientLoginEnabled && loginMode === 'client') {
      setLoginMode('staff');
      window.dispatchEvent(new Event('client-logged-out'));
    }
  }, [clientLoginEnabled, loginMode]);

  useEffect(() => {
    // Prevent overriding to 'staff' if we are on a white-label URL
    if (!hasClientLoginTarget && loginMode === 'client' && !isWhiteLabelUrl && urlStoreSlug === '' && isMasterHost(window.location.hostname)) {
      setLoginMode('staff');
    }
  }, [hasClientLoginTarget, loginMode, isWhiteLabelUrl, urlStoreSlug]);

  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('app_logged_in') === 'true';
  });
  const [showLogin, setShowLogin] = useState(() => {
    return localStorage.getItem('app_logged_in') !== 'true';
  });
  const [loginData, setLoginData] = useState({ username: "", password: "" });
  const [rememberSession, setRememberSession] = useState(true);
  const [isInitialSyncing, setIsInitialSyncing] = useState(false);
  const [showSyncEscape, setShowSyncEscape] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [isRegistering, setIsRegistering] = useState(false);
  const [registerName, setRegisterName] = useState("");
  // Moved loginMode up to fix TDZ
  useEffect(() => {
    localStorage.setItem('app_login_mode', loginMode);
  }, [loginMode]);

  // Reveal the sync emergency-exit only if the initial sync actually stalls
  // (the old animationDelay trick never ran — no animation was defined).
  useEffect(() => {
    if (!isInitialSyncing) { setShowSyncEscape(false); return; }
    const t = setTimeout(() => setShowSyncEscape(true), 15000);
    return () => clearTimeout(t);
  }, [isInitialSyncing]);

  // Guest storefront (free-plan default template): unauthenticated visitors
  // on a store URL browse the public catalog; buying/registering flips to
  // the login screen. On /loja/{slug} only a URL-resolved store is
  // acceptable — never fall back to the staff session's active store, or the
  // catalog would show the wrong shop.
  const urlResolvedStore = urlStore || loginStore;
  const guestStore = isStorefrontPath
    ? urlResolvedStore
    : (urlResolvedStore || multiStore.find(s => s.id === activeStoreId));
  const guestStoreConfig = guestStore?.config || (isStorefrontPath ? {} : activeStoreConfig) || {};
  // NOTE: named isNativeGuestStore (not isNativeStore) — the latter is an
  // imported helper from storeConnections used above for tab capabilities;
  // shadowing it here would be a TDZ ReferenceError during render.
  const isNativeGuestStore = guestStoreConfig?.connectionType === 'native';
  const storefrontEnabled = guestStoreConfig?.storefrontEnabled !== false;
  // /loja/{slug} is always the public storefront for ANY resolved store —
  // native or Woo — for guests AND logged-in staff (that is what
  // "Ver na Loja" opens). /{slug} shows the storefront for native stores
  // with client login enabled; staff management stays at /login.
  const showGuestStorefront = !guestWantsLogin && storefrontEnabled && isWhiteLabelUrl &&
    (isStorefrontPath ? !!urlResolvedStore : (isNativeGuestStore && clientLoginEnabled));

  // Guests never run the logged-in config sync — fetch the multistore list
  // anyway so a store slug in the URL resolves its config (storefront,
  // client-login toggle, native routing). On /loja/{slug} this also runs for
  // logged-in staff: the URL store must come from the server list, not the
  // (possibly stale) local multistore cache, or the storefront silently
  // falls back to the active staff store's connection type.
  useEffect(() => {
    const isStaffSession = localStorage.getItem('app_logged_in') === 'true';
    if (isStaffSession && !isStorefrontPath) return;
    // On a store custom domain there is no slug in the path — the store is
    // resolved by hostname (customDomain match below), so the list still
    // needs to load even with an empty urlStoreSlug.
    const onStoreDomain = !isMasterHost(window.location.hostname);
    if (!urlStoreSlug && !onStoreDomain) return;
    if (urlStoreSlug && ['login', 'signup', 'onboarding', 'wallet', 'privacidade', 'cookies'].includes(urlStoreSlug)) return;
    (async () => {
      try {
        const remote = await loadKVFromServer('global_multistore');
        const list = Array.isArray(remote) ? remote : [];
        if (list.length > 0) {
          setMultiStore(list);
          localStorage.setItem('wc_multistore', JSON.stringify(list));
        }
        let match = list.find(s =>
          normUrl(s.config?.customUrl) === urlStoreSlug ||
          s.config?.customDomain?.toLowerCase() === window.location.hostname.toLowerCase()
        );
        // Fallback: the shared multistore may not contain the store (it can
        // be overwritten by stale clients). Resolve via the public catalog
        // endpoint, which falls back to the `stores` table, and synthesize
        // a minimal native config so guest checkout/cart work for visitors.
        if (!match && urlStoreSlug) {
          try {
            const res = await fetch(getServerUrl(`catalog/${encodeURIComponent(urlStoreSlug)}?per_page=1`), {
              headers: { apikey: publicAnonKey },
            });
            const cat = await res.json().catch(() => ({}));
            if (cat?.store?.type === 'native' && cat.store.store_id) {
              match = {
                id: cat.store.store_id,
                name: cat.store.name || urlStoreSlug,
                config: {
                  version: 'v3',
                  useProxy: true,
                  url: '',
                  consumerKey: '',
                  consumerSecret: '',
                  connectionType: 'native',
                  nativeStoreId: cat.store.store_id,
                  customUrl: urlStoreSlug,
                  currency: cat.store.currency || 'EUR',
                },
              };
            }
          } catch { /* catalog unreachable — leave unresolved */ }
        }
        if (match) {
          setUrlStore(match);
          setActiveStoreId(match.id);
          localStorage.setItem('wc_active_store_id', match.id);
          localStorage.setItem('wcactivestoreid', match.id);
          saveConfig(match.config);
        }
      } catch (e) {
        console.warn('[Guest] Could not load store config:', e);
      }
    })();
  }, [urlStoreSlug, isStorefrontPath]);

  const clearStaffSession = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('app_logged_in');
    localStorage.removeItem('app_username');
    localStorage.removeItem('app_user_role');
    localStorage.removeItem('is_master_admin');
    localStorage.removeItem('allowed_stores');
    localStorage.removeItem('swiftwoo_jwt_token');
    localStorage.removeItem('last_login_timestamp');
    localStorage.removeItem('pwa_store_slug');
    document.documentElement.style.setProperty('--brand', '#10B981');
  };

  const clearClientSession = (storeId = activeStoreId) => {
    clientAuth.logout(storeId);
    localStorage.removeItem(`client_id_${storeId}`);
    localStorage.removeItem(`client_email_${storeId}`);
    localStorage.removeItem(`client_display_name_${storeId}`);
    localStorage.removeItem(`client_store_url_${storeId}`);
    setClientAuthenticated(false);
    setClientUser(null);
    window.dispatchEvent(new Event('client-logged-out'));
  };

  // White-label branding: ONLY apply custom logo/color when the user arrived
  // via a store's custom URL (e.g. /cannabis). Default login → always app branding.

  useEffect(() => {
    // Default brand color
    let newColor = '#10B981';

    if (isWhiteLabelUrl && brandConfig?.brand_color) {
      newColor = brandConfig.brand_color;
    } else if (isLoggedIn && activeStoreConfig?.themeColor) {
      newColor = activeStoreConfig.themeColor;
    }

    document.documentElement.style.setProperty('--brand', newColor);
    document.documentElement.style.setProperty('--brand-color', newColor);

    // Auto-apply theme if white label forces it (override user pref for login screen)
    if (!isLoggedIn && brandConfig?.theme_mode === 'light') {
      document.documentElement.classList.add('light');
      document.documentElement.classList.remove('dark');
      setIsDarkMode(false);
    } else if (!isLoggedIn && brandConfig?.theme_mode === 'dark') {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
      setIsDarkMode(true);
    }

    if (isWhiteLabelUrl) {
      const storeByUrl = multiStore.find(s => normUrl(s.config?.customUrl) === urlStoreSlug);
      const pwaName = brandConfig?.name || storeByUrl?.config?.name;
      if (pwaName) document.title = pwaName;
    }

    // NOTE: The dynamic PWA <link rel="manifest"> (name/icon/start_url) is
    // owned by BrandContext (src/app/store/BrandContext.tsx) and the early
    // bootstrap in main.tsx, which have the actual store data available
    // before this component mounts. This effect used to also regenerate the
    // manifest here using hardcoded "LojaPilot" fallback values and a
    // relative start_url, which — because it re-ran whenever isWhiteLabelUrl
    // was momentarily false (e.g. while brandConfig/multiStore were still
    // loading) — clobbered the correct store name/icon set elsewhere with
    // the generic defaults. It has been removed to avoid that race.
  }, [isLoggedIn, activeStoreConfig?.themeColor, brandConfig, isWhiteLabelUrl, multiStore, urlStoreSlug]);

  // Módulo Agente IA — injects the store's pasted embed script for logged-in
  // staff (managers/POS). Configured per-store by Master in settings; billed
  // as a monthly extra. Cleanup removes the script and any widget nodes it
  // appended to <body> so switching store/disabling the module works.
  const aiAgentScript = (activeStoreConfig as any)?.aiAgentEnabled ? (activeStoreConfig as any)?.aiAgentScript : '';
  useEffect(() => {
    const embed = isLoggedIn ? parseAgentEmbed(aiAgentScript || '') : null;
    if (!embed) return;
    const s = document.createElement('script');
    s.src = embed.src;
    s.async = true;
    if (embed.siteId) s.dataset.siteId = embed.siteId;
    if (embed.apiUrl) s.dataset.apiUrl = embed.apiUrl;
    const slug = (activeStoreConfig?.customUrl || String(activeStoreId) || '').toLowerCase();
    if (slug) s.dataset.storeSlug = slug;
    document.head.appendChild(s);
    return () => {
      document.querySelectorAll(`script[src="${embed.src}"]`).forEach(n => n.remove());
      document.querySelectorAll(
        'body > [id*="chatbot"], body > [class*="chatbot"], body > [id*="chat-widget"], body > [class*="chat-widget"], body > [id*="swiftchat"], body > [class*="swiftchat"], body > iframe[src*="swiftapps"]'
      ).forEach(n => n.remove());
    };
  }, [isLoggedIn, activeStoreId, aiAgentScript, activeStoreConfig?.customUrl]);

  useEffect(() => {
    const validateSession = async () => {
      // On /loja/{slug} the URL store is not the session store — validating a
      // staff token against the storefront's (possibly unrelated) URL could
      // force a bogus logout, so skip session validation here entirely.
      if (window.location.pathname.split('/').filter(Boolean)[0]?.toLowerCase() === 'loja') return;

      const pluginToken = getSwiftWooJwt();
      const clientToken = localStorage.getItem(`client_token_${activeStoreId}`);
      const token = pluginToken || clientToken;

      if (localStorage.getItem('swiftwoo_jwt_token') && !pluginToken) {
        handleLogout();
        return;
      }

      // Only validate plugin tokens — Supabase master sessions are managed by Supabase itself.
      // If there is no plugin JWT but the user is marked as logged in, it was a Supabase-only login.
      if (!token) return;

      if (token && isLoggedIn) {
        try {
          const storeUrl = (window as any).__brandConfig?.url || localStorage.getItem('wc_active_store_url');
          if (!storeUrl) {
            console.warn('[Session] Store URL missing, skipping validation.');
            return;
          }
          const isValid = await PluginApiClient.validate(storeUrl, token);
          if (!isValid) {
            // Only log out if the plugin token is invalid. Don't log out on network failures.
            handleLogout();
          }
        } catch (error) {
          // Network failure — don't force logout; let the user continue offline.
          console.warn('[Session] Token validation failed (network?), staying logged in.', error);
        }
      }
    };
    validateSession();
  }, []);

  useEffect(() => {
    const syncConfig = async () => {
      // Only sync from server if we are logged in
      if (localStorage.getItem('app_logged_in') !== 'true') return;

      try {


        console.log("[App] Syncing configuration from server...");

        // 1. Load global multistore list
        const remoteMultiStore = await loadKVFromServer('global_multistore');
        if (Array.isArray(remoteMultiStore) && remoteMultiStore.length > 0) {
          console.log(`[App] Found ${remoteMultiStore.length} stores on server.`);
          localStorage.setItem('wc_multistore', JSON.stringify(remoteMultiStore));
          setMultiStore(remoteMultiStore);

          // CRITICAL: Ensure the active store's config is applied immediately from the multiStore list
          let activeId = localStorage.getItem('wc_active_store_id') || 'default';

          // White Label: Check URL path for custom store routing — skip the
          // /loja/ prefix so /loja/{slug} resolves {slug}, not "loja".
          const __syncParts = window.location.pathname.split('/').filter(Boolean);
          const pathSegment = (__syncParts[0]?.toLowerCase() === 'loja' ? __syncParts[1] : __syncParts[0]) || '';
          if (pathSegment) {
            const routeStore = remoteMultiStore.find(s => normUrl(s.config?.customUrl) === pathSegment.toLowerCase());
            if (routeStore) {
              console.log(`[WhiteLabel] Matched store ${routeStore.name} from URL /${pathSegment}`);
              activeId = routeStore.id;
              setActiveStoreId(activeId);
              localStorage.setItem('wc_active_store_id', activeId);
              localStorage.setItem('wcactivestoreid', activeId);
            }
          }

          let activeStore = remoteMultiStore.find(s => s.id === activeId);

          const isMaster = localStorage.getItem('is_master_admin') === 'true';
          const allowed = JSON.parse(localStorage.getItem('allowed_stores') || "[]");
          const hasAccess = isMaster || allowed.includes(activeId);

          if (!activeStore || !hasAccess) {
            const fallbackStore = remoteMultiStore.find(s => isMaster || allowed.includes(s.id));
            activeStore = fallbackStore || remoteMultiStore[0];
            localStorage.setItem('wc_active_store_id', activeStore.id);
            localStorage.setItem('wcactivestoreid', activeStore.id);
          }

          // On /loja/{slug} the URL-store effect owns the applied config —
          // repointing to a fallback active store here would race with it
          // and break the public storefront for staff without store access.
          const onPublicStorefront = window.location.pathname.split('/').filter(Boolean)[0]?.toLowerCase() === 'loja';

          if (activeStore && activeStore.config && !onPublicStorefront) {
            console.log(`[App] Applying config for active store: ${activeStore.name} (${activeStore.id})`);
            // If the server config rotated credentials (e.g. plugin
            // re-pairing generated new REST keys), the applied wc_config
            // changes for the SAME store — components keep showing stale
            // IndexedDB data unless we notify them. store-switched is the
            // event they already handle by reloading for the active store.
            const prevConfig = loadConfig();
            const credsChanged =
              prevConfig &&
              (prevConfig.consumerKey !== activeStore.config.consumerKey ||
                prevConfig.consumerSecret !== activeStore.config.consumerSecret ||
                prevConfig.url !== activeStore.config.url);
            saveConfig(activeStore.config);
            if (credsChanged) {
              console.log('[App] Store credentials changed — refreshing views');
              window.dispatchEvent(new Event('storage'));
              window.dispatchEvent(new CustomEvent('store-switched'));
            }

            // Manifest identity must match the white-label slug used by the
            // bootstrap manifest — falling back to the internal store id
            // produced a bogus start_url (/store_xxx) and a duplicate app id.
            const manifestSlug =
              activeStore.config?.customUrl ||
              localStorage.getItem('pwa_store_slug') ||
              'default';

            updateStoreManifest(
              {
                name: activeStore.name || activeStore.config?.name,
                slug: manifestSlug,
                logo_url:
                  activeStore.config?.logoUrl ||
                  activeStore.config?.logo_url,
                apple_touch_icon_url:
                  activeStore.config?.appleTouchIconUrl ||
                  activeStore.config?.apple_touch_icon_url,
                brand_color:
                  activeStore.config?.themeColor ||
                  activeStore.config?.brand_color,
                theme_mode: activeStore.config?.theme_mode,
                custom_domain: activeStore.config?.customDomain
              },
              manifestSlug
            );
          }
        }

        await new Promise(r => setTimeout(r, 300));

        // 2. Load the general settings as fallback
        const serverConfig = await loadConfigFromServer();
        if (serverConfig) {
          // If we don't have a multistore list yet, initialize it
          if (!localStorage.getItem('wc_multistore')) {
            const initial = [{
              id: 'default',
              name: serverConfig.url ? new URL(serverConfig.url).hostname : 'My Store',
              config: serverConfig
            }];
            localStorage.setItem('wc_multistore', JSON.stringify(initial));
            setMultiStore(initial);
            saveConfig(serverConfig);

            const activeInitialStore = initial[0];
            const manifestSlugInitial =
              activeInitialStore.config?.customUrl ||
              localStorage.getItem('pwa_store_slug') ||
              'default';

            updateStoreManifest(
              {
                name: activeInitialStore.name || activeInitialStore.config?.name,
                slug: manifestSlugInitial,
                logo_url:
                  activeInitialStore.config?.logoUrl ||
                  activeInitialStore.config?.logo_url,
                apple_touch_icon_url:
                  activeInitialStore.config?.appleTouchIconUrl ||
                  activeInitialStore.config?.apple_touch_icon_url,
                brand_color:
                  activeInitialStore.config?.themeColor ||
                  activeInitialStore.config?.brand_color,
                theme_mode: activeInitialStore.config?.theme_mode,
                custom_domain: activeInitialStore.config?.customDomain
              },
              manifestSlugInitial
            );
          }
        }
      } catch (err) {
        console.error("[App] Initial sync failed:", err);
      }
    };

    syncConfig();

    // Removido listener de 'config-updated' para evitar loop infinito
  }, []);


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    if (token) {
      try {
        const decoded = atob(token);
        const [username, password] = decoded.split(':');
        if (username) {
          setLoginData({ username, password });
          performLogin(username, password || '');
          // Remove token from URL for security
          window.history.replaceState({}, document.title, window.location.pathname);
        }
      } catch (err) {
        console.error("Invalid token format");
      }
    }
  }, []);

  const performLogin = async (username: string, password?: string) => {
    setIsLoggingIn(true);

    try {
      let data: any = null;
      let isSupabaseFallback = false;
      let token = '';
      let matchedUser: any = null;

      try {
        const storeUrl = resolveStoreUrl();
        if (!storeUrl) throw new Error("Store URL missing for plugin login.");
        data = await PluginApiClient.login(storeUrl, username, password || '', rememberSession);

        console.log("[Login Debug] Token from server:", data?.token);
        const isLikely = isLikelySwiftWooJwt(data?.token);
        console.log("[Login Debug] Passes isLikelySwiftWooJwt?", isLikely);

        if (!data?.token || !isLikely) {
          throw new Error("O servidor não devolveu um JWT válido.");
        }
        token = data.token;
      } catch (pluginErr: any) {
        console.warn("[Login] Plugin login failed:", pluginErr);
        console.warn("[Login] Falling back to Supabase Auth");

        let loginEmail = username;

        try {
          const { data: kvData } = await supabase
            .from('swift_kv_store_75caf0c1')
            .select('value')
            .eq('key', 'system_users_registry_v1')
            .maybeSingle();

          if (kvData?.value && Array.isArray(kvData.value)) {
            matchedUser = kvData.value.find((u: any) => u.username === username || u.email === username);
            if (matchedUser && matchedUser.email && !loginEmail.includes('@')) {
              loginEmail = matchedUser.email;
            }
          }
        } catch (e) {
          console.warn("Failed to lookup email by username", e);
        }

        const { data: supaData, error: supaErr } = await supabase.auth.signInWithPassword({
          email: loginEmail,
          password: password || ''
        });

        if (supaErr || !supaData.session?.access_token) {
          throw new Error(`Erro WP: ${pluginErr.message} | Supabase: Credenciais inválidas`);
        }

        token = supaData.session.access_token;
        const role = supaData.user?.user_metadata?.role || matchedUser?.role || 'master_admin';
        data = {
          token: token,
          user: {
            username: username,
            email: supaData.user?.email || username,
            display_name: supaData.user?.user_metadata?.first_name || username,
            roles: [role],
            role: role
          },
          brand: { brand_key: activeStoreId, store_url: '' }
        };
        isSupabaseFallback = true;
      }
      if (data && token) {
        if (!matchedUser) {
          try {
            const { data: kvData } = await supabase
              .from('swift_kv_store_75caf0c1')
              .select('value')
              .eq('key', 'system_users_registry_v1')
              .maybeSingle();

            if (kvData?.value && Array.isArray(kvData.value)) {
              matchedUser = kvData.value.find((u: any) =>
                u.username === username ||
                u.email === username ||
                (data.user?.email && u.email === data.user.email) ||
                (data.user?.username && u.username === data.user.username)
              );
            }
          } catch (e) {
            console.warn("Failed to lookup KV user after plugin login", e);
          }
        }

        clearClientSession(localStorage.getItem('wc_active_store_id') || activeStoreId);

        setIsLoggedIn(true);
        localStorage.setItem('app_logged_in', 'true');
        if (!isSupabaseFallback) {
          localStorage.setItem('swiftwoo_jwt_token', token);
        }

        const finalAppUsername = matchedUser?.username || data.user?.username || username;
        localStorage.setItem('app_username', finalAppUsername);
        if (matchedUser?.id) {
          localStorage.setItem('app_user_id', matchedUser.id);
        }
        localStorage.setItem('last_login_timestamp', Date.now().toString());

        const wpRoles = Array.isArray(data.user?.roles) ? data.user.roles : [];
        const normalizedRoles = wpRoles.map((role: any) => String(role || '').toLowerCase());
        const isMaster = normalizedRoles.some((r: string) => r.includes('admin')) || String(data.user?.role || '').toLowerCase().includes('admin');
        const role = isMaster
          ? 'master_admin'
          : (normalizedRoles.includes('shop_manager') || normalizedRoles.includes('manager') ? 'manager' : 'pos');

        localStorage.setItem('app_user_role', role);
        localStorage.setItem('is_master_admin', isMaster.toString());

        // Avatar: prefer KV store, fallback to plugin response, and finally Supabase user_metadata
        if (matchedUser?.avatar_url) {
          localStorage.setItem(`user_avatar_${finalAppUsername}`, matchedUser.avatar_url);
        } else if (data.user?.avatar_url) {
          localStorage.setItem(`user_avatar_${finalAppUsername}`, data.user.avatar_url);
        } else if (isSupabaseFallback) {
          const { data: { user: supaUser } } = await supabase.auth.getUser();
          const metaAvatar = supaUser?.user_metadata?.avatar_url || supaUser?.user_metadata?.picture;
          const kvAvatar = matchedUser?.avatar_url;

          if (metaAvatar || kvAvatar) {
            localStorage.setItem(`user_avatar_${finalAppUsername}`, metaAvatar || kvAvatar);
          } else {
            localStorage.removeItem(`user_avatar_${finalAppUsername}`);
          }
        } else {
          localStorage.removeItem(`user_avatar_${finalAppUsername}`);
        }

        if (data.user?.display_name) {
          const parts = data.user.display_name.split(' ');
          localStorage.setItem(`user_first_name_${finalAppUsername}`, parts[0]);
          if (parts.length > 1) {
            localStorage.setItem(`user_last_name_${finalAppUsername}`, parts.slice(1).join(' '));
          }
        }
        if (data.user?.email) localStorage.setItem(`user_email_${finalAppUsername}`, data.user.email);

        // Refresh header identity (name + avatar) immediately — the 'storage'
        // event further down only fires when the multistore block runs, so a
        // POS login could keep showing the previous user's avatar.
        fetchProfileLocal();

        let finalActiveId = 'default';
        let matchedStore = null;

        const remoteMultiStore = await loadKVFromServer('global_multistore');

        if (Array.isArray(remoteMultiStore) && remoteMultiStore.length > 0) {
          // Find the store in global_multistore that matches the brand's store_url
          const targetUrl = data.brand?.store_url?.replace(/\/$/, '') || '';
          matchedStore = remoteMultiStore.find(s => {
            const sUrl = s.config?.url?.replace(/\/$/, '') || '';
            return sUrl === targetUrl;
          });

          if (matchedStore) {
            finalActiveId = matchedStore.id;
          } else {
            // Fallback: just use the first store if we can't match the URL
            finalActiveId = remoteMultiStore[0].id;
            matchedStore = remoteMultiStore[0];
          }
        }

        localStorage.setItem('allowed_stores', JSON.stringify([finalActiveId]));
        localStorage.setItem('wc_active_store_id', finalActiveId);
        localStorage.setItem('wcactivestoreid', finalActiveId); // For compatibility
        setActiveStoreId(finalActiveId);

        toast.success(`Bem-vindo/a de volta, ${data.user?.display_name || username}!`);
        addAppLog('info', 'System Login', `User ${username} logged in successfully`, {
          entityType: 'user'
        });

        // 1. Reload multiStore from server to ensure latest list and save the active config

        if (Array.isArray(remoteMultiStore) && remoteMultiStore.length > 0) {
          localStorage.setItem('wc_multistore', JSON.stringify(remoteMultiStore));
          setMultiStore(remoteMultiStore);

          const assignedStores = [finalActiveId]; // The user has access to the store they just matched
          const hasAccess = isMaster || assignedStores.includes(finalActiveId);

          let activeStore = matchedStore;
          if (!activeStore || !hasAccess) {
            const fallbackStore = remoteMultiStore.find(s => isMaster || assignedStores.includes(s.id));
            activeStore = fallbackStore || remoteMultiStore[0];
            finalActiveId = activeStore.id;
            localStorage.setItem('wc_active_store_id', finalActiveId);
            localStorage.setItem('wcactivestoreid', finalActiveId);
            setActiveStoreId(finalActiveId);
          }

          if (activeStore && activeStore.config) {
            saveConfig(activeStore.config);
          }

          window.dispatchEvent(new Event('storage'));
        }

        // 2. Check Cache for SWR (Stale-While-Revalidate)

        const cachedProducts = await db.products.where('storeId').equals(finalActiveId).count();
        const hasCache = cachedProducts > 0;

        if (hasCache) {
          // A - Fluxo com Cache (SWR)
          console.log("[App] Cache found. Starting background sync.");
          setShowLogin(false);
          setIsInitialSyncing(false);

          // Fire sync asynchronously in silent mode
          SyncService.forceSync((msg) => {
            // we can still log quietly or completely ignore
          }, true).catch(err => {
            console.error("Background sync failed:", err);
          });

        } else {
          // B - Fluxo Inicial (Sem Cache)
          console.log("[App] No cache found. Starting blocking initial sync.");
          setIsInitialSyncing(true);

          // SAFETY: 45s hard timeout — if sync hangs, show the app anyway
          const syncTimeout = setTimeout(() => {
            console.warn("[App] Sync timeout reached after 45s. Forcing app to load.");
            setIsInitialSyncing(false);
            setShowLogin(false);
          }, 45000);

          try {
            await db.clearStoreData(finalActiveId).catch(() => { }); // ignore clear errors
            await SyncService.forceSync((msg) => {
              console.log(`[Global Sync] ${msg}`);
            });
            toast.success('Loja sincronizada com sucesso!');
            window.dispatchEvent(new CustomEvent('config-updated'));
          } catch (syncErr) {
            console.error("Global sync failed:", syncErr);
            toast.error("Sincronização falhou. Pode continuar — dados podem estar incompletos.");
          } finally {
            clearTimeout(syncTimeout);
            setIsInitialSyncing(false);
            setShowLogin(false);
          }
        }

        // 3. Initialize OneSignal User and Prompt Push
        try {
          const windowObj = (window as any);
          if (windowObj.OneSignalDeferred) {
            windowObj.OneSignalDeferred.push(async function (OneSignal: any) {
              try {
                const identifier = data.user?.username || data.user?.id || data.user?.email;
                if (identifier && String(identifier).trim() !== '' && String(identifier) !== 'undefined') {
                  // Login to OneSignal with identifier so notifications can be targeted
                  await OneSignal.login(String(identifier));
                  // Set tags for specific targeting — this is the staff
                  // login path, so the audience tag must be the literal
                  // 'staff' the backend filters on (Woo role names like
                  // 'administrator'/'shop_manager' would silently opt the
                  // device out of order notifications).
                  if (OneSignal.User && OneSignal.User.addTags) {
                    OneSignal.User.addTags({
                      store_id: finalActiveId,
                      role: 'staff'
                    });
                  }
                  // Prompt user to subscribe
                  if (OneSignal.Slidedown && OneSignal.Slidedown.promptPush) {
                    await OneSignal.Slidedown.promptPush();
                  }
                  console.log('[OneSignal] User logged in and push prompted.');
                }
              } catch (e) {
                console.warn('[OneSignal] Deferred login error:', e);
              }
            });
          }
        } catch (e) {
          console.warn('[OneSignal] Could not prompt push after login:', e);
        }

        // Subscrição Native Web Push (Shadow Mode) para Staff
        subscribeToPush(
          localStorage.getItem('pwa_store_slug') || finalActiveId,
          'staff',
          loginData.username
        );

        return;
      } else {
        toast.error("Email ou palavra-passe incorretos. Tente novamente.");
        addAppLog('error', 'Login', 'Invalid response format');
      }
    } catch (err: any) {
      console.error('[Login] Request error:', err);

      if (err.name === 'AbortError') {
        toast.error("O pedido excedeu o tempo limite. Verifique a sua ligação e tente novamente.");
        addAppLog('error', 'Login', 'Request timeout');
      } else if (err.message === 'Failed to fetch') {
        toast.error("Não foi possível ligar ao servidor. Verifique a sua ligação à internet.");
        addAppLog('error', 'Login', 'Network error - Failed to fetch');
      } else {
        toast.error("Email ou palavra-passe incorretos. Tente novamente.");
        addAppLog('error', 'Login', `Request failed: ${err.message}`);
      }
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loginMode === 'client' && clientLoginEnabled) {
      if (isRegistering) {
        await performClientRegister();
      } else {
        await performClientLogin(loginData.username, loginData.password);
      }
    } else {
      await performLogin(loginData.username, loginData.password);
    }
  };

  // Self-service customer registration on native stores — creates the
  // customer account server-side and signs the client in immediately.
  const performClientRegister = async () => {
    setIsLoggingIn(true);
    try {
      const clientStoreConfig = { ...activeStoreConfig, url: resolveStoreUrl() };
      const result = await clientAuth.register(clientStoreConfig, activeStoreId, {
        email: loginData.username.trim(),
        password: loginData.password,
        first_name: registerName.trim(),
      });
      localStorage.setItem(`client_email_${activeStoreId}`, result.user_email);
      localStorage.setItem(`client_display_name_${activeStoreId}`, result.user_display_name);
      window.dispatchEvent(new CustomEvent('client-logged-in', {
        detail: { storeId: activeStoreId, user: { user_email: result.user_email, user_display_name: result.user_display_name } }
      }));
      setShowLogin(false);
      toast.success(`Bem-vindo(a), ${result.user_display_name}`);
    } catch (error: any) {
      toast.error(error?.message || 'Não foi possível criar a conta.');
    } finally {
      setIsLoggingIn(false);
    }
  };

  const performClientLogin = async (username: string, password?: string) => {
    setIsLoggingIn(true);
    try {
      let data: any = null;

      // Autenticação direta JWT via WooCommerce API
      try {
        const clientStoreConfig = { ...activeStoreConfig, url: resolveStoreUrl() };
        const result = await clientAuth.login(clientStoreConfig, activeStoreId, username, password || '', rememberSession);
        const u = result.user || {};

        data = {
          token: result.token,
          user: {
            id: result.customer_id || u.id || username, // native stores return the real customer id
            username: u.username || username,
            email: result.user_email || u.email || username,
            display_name: result.user_display_name || u.display_name || username,
            roles: (u.roles || result.roles || []).length ? (u.roles || result.roles) : ['customer'],
            avatar_url: u.avatar_url || result.avatar_url || null,
          },
          brand: { brand_key: activeStoreId, store_url: activeStoreConfig.url }
        };
      } catch (pluginErr: any) {
        console.warn('[Client Login] Direct JWT login failed:', pluginErr);
        throw pluginErr;
      }

      if (!data || !data.token) {
        toast.error("Erro de autenticação.");
        setIsLoggingIn(false);
        return;
      }

      const roles = Array.isArray(data.user?.roles) ? data.user.roles : [data.user?.role].filter(Boolean);
      const normalizedRoles = roles.map((role: any) => String(role || '').toLowerCase());
      const isStaffAccount = normalizedRoles.some((role) => ['administrator', 'shop_manager', 'manager', 'staff', 'pos', 'editor', 'author'].includes(role)) ||
        ['administrator', 'shop_manager', 'manager', 'staff', 'pos'].includes(String(data.user?.role || '').toLowerCase());

      if (isStaffAccount) {
        setLoginMode('staff');
        window.dispatchEvent(new Event('client-logged-out'));
        toast.error('Esta conta é de staff. Use o separador "Acesso Staff".');
        return;
      }

      // 1. DO NOT wipe staff session. Total isolation for JWT.
      setLoginMode('client');

      const token = data.token;
      const effectiveStoreId = (activeStoreId && activeStoreId !== 'default') ? activeStoreId : (data.brand?.brand_key || activeStoreId);
      const storeUrl = data.brand?.store_url || activeStoreConfig?.url;

      localStorage.setItem(`client_token_${effectiveStoreId}`, token);
      if (storeUrl) localStorage.setItem(`client_store_url_${effectiveStoreId}`, storeUrl);

      const userData = data.user;
      if (userData && userData.id) {
        localStorage.setItem(`client_id_${effectiveStoreId}`, userData.id.toString());
        localStorage.setItem(`client_email_${effectiveStoreId}`, userData.email || username);
        localStorage.setItem(`client_display_name_${effectiveStoreId}`, userData.display_name || username);
      } else {
        localStorage.setItem(`client_email_${effectiveStoreId}`, username);
        localStorage.setItem(`client_display_name_${effectiveStoreId}`, username);
      }

      const customerId = localStorage.getItem(`client_id_${effectiveStoreId}`);
      if (customerId && typeof (window as any).__initOneSignal === 'function') {
        (window as any).__initOneSignal(customerId);
      }

      subscribeToPush(localStorage.getItem('pwa_store_slug') || 'default', 'client', customerId || undefined);

      // 2. Dispatch event to set clientAuthenticated, but do not set isLoggedIn globally
      const userDisplayName = data.user?.display_name || username;
      window.dispatchEvent(new CustomEvent('client-logged-in', {
        detail: {
          storeId: effectiveStoreId,
          user: { user_email: userData?.email || username, user_display_name: userDisplayName }
        }
      }));

      setShowLogin(false);
      toast.success(`Bem-vindo(a), ${userDisplayName}`);

    } catch (error: any) {
      console.error('[Client Login] Error:', error);
      const msg = String(error?.message || '');
      const lc = msg.toLowerCase();
      if ((error as any)?.isConfigError || msg.includes('MISSING_CONFIG')) {
        toast.error('Login de clientes indisponível — esta loja não tem o plugin LojaPilot Connect ativo.');
      } else if (lc.includes('credential') || lc.includes('incorrect') || lc.includes('password') || lc.includes('credenciais') || lc.includes('invalid')) {
        toast.error('Email ou palavra-passe incorretos.');
      } else if (lc.includes('too many') || lc.includes('rate') || lc.includes('throttl')) {
        toast.error('Demasiadas tentativas de login. Aguarda alguns minutos e tenta novamente.');
      } else if (msg.includes('TIMEOUT') || lc.includes('fetch') || lc.includes('network') || msg.includes('SERVER_ERROR') || msg.includes('SERVICE_UNAVAILABLE') || msg.includes('INVALID_RESPONSE')) {
        toast.error('Falha ao contactar o servidor da loja. Verifica a tua ligação e tenta novamente.');
      } else if (msg) {
        toast.error(msg.length > 140 ? msg.slice(0, 140) : msg);
      } else {
        toast.error('Falha ao contactar o servidor da loja.');
      }
    } finally {
      setIsLoggingIn(false);
    }
  };

  const handleLogout = async () => {
    const wasClient = loginMode === 'client';

    if (typeof window !== 'undefined' && (window as any).OneSignalDeferred) {
      (window as any).OneSignalDeferred.push(function (OneSignal: any) {
        OneSignal.User.removeTags(['store_slug', 'user_role', 'storeId', 'role', 'store_id']);
        OneSignal.logout();
        console.log("[OneSignal] Identidade e tags removidas no logout");
      });
    }

    const storeUrl = resolveStoreUrl();

    if (wasClient) {
      const clientToken = localStorage.getItem(`client_token_${activeStoreId}`);
      if (clientToken && storeUrl) {
        PluginApiClient.revoke(storeUrl, clientToken).catch(console.error);
      }
      clearClientSession(activeStoreId);
      setClientAuthenticated(false);
      setClientUser(null);
      window.dispatchEvent(new Event('client-logged-out'));

      if (isLoggedIn) {
        // Se a sessão staff existir, volta apenas para o modo staff sem dar redirect total
        setLoginMode('staff');
        return;
      }
    } else {
      const staffToken = localStorage.getItem('swiftwoo_jwt_token');
      if (staffToken && storeUrl) {
        PluginApiClient.revoke(storeUrl, staffToken).catch(console.error);
      }
      await supabase.auth.signOut().catch(console.error);
      clearStaffSession();
      // Opcional: limpar também o cliente se houver um log out completo
      clearClientSession(activeStoreId);
    }

    const __logoutParts = window.location.pathname.split('/').filter(Boolean);
    const onStorefrontPath = __logoutParts[0]?.toLowerCase() === 'loja' && !!__logoutParts[1];
    const currentSlug = (onStorefrontPath ? __logoutParts[1] : __logoutParts[0])?.toLowerCase() || '';
    const validSlug = (currentSlug === 'login' || currentSlug === 'wallet' || currentSlug === 'loja') ? '' : currentSlug;

    // Always trust the browser's current URL for redirecting on logout to
    // avoid stale closures — after leaving a public storefront, land back on
    // it (/loja/{slug}) instead of the store app.
    const targetPath = onStorefrontPath && validSlug ? `/loja/${validSlug}` : (validSlug ? `/${validSlug}` : '/login');
    window.location.href = targetPath;
  };

  useEffect(() => {
    SyncService.init();
  }, []);



  const handleGlobalRefresh = async () => {
    if (SyncService.isSyncing) return;

    setIsSyncing(true);
    try {
      // Coordinated preload of all tabs at once
      await SyncService.preloadAllTabs(activeStoreId);
      await fetchNotifications();
      toast.success("Todos os separadores atualizados!");
    } catch (error) {
      console.error("Refresh failed", error);
      toast.error("Falha ao atualizar alguns dados.");
    } finally {
      setIsSyncing(false);
    }
  };

  const renderView = () => {
    const isMaster = localStorage.getItem('is_master_admin') === 'true';
    const hidden = JSON.parse(localStorage.getItem('hidden_tabs_wc') || "[]");

    const appUserRole = localStorage.getItem('app_user_role') || 'manager';
    const isPos = appUserRole === 'pos';

    // POS Route Guard — POS can see products, orders, stock, loyalty and account
    if (isPos && !['pos_products', 'orders', 'stock', 'loyalty', 'account'].includes(currentView)) {
      setTimeout(() => setCurrentView("pos_products"), 0);
      return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center animate-in fade-in zoom-in duration-300">
          <Shield className="w-12 h-12 text-rose-500 mb-4 opacity-80" />
          <h2 className="text-xl font-bold text-slate-800 dark:text-slate-200 mb-2">Acesso Restrito</h2>
          <p className="text-slate-500 dark:text-slate-400">Não tem permissões para aceder a esta área.</p>
        </div>
      );
    }

    // RBAC Route Guard: Block Hidden Tabs for Store Managers
    if (!isMaster && !isPos && hidden.includes(currentView)) {
      setTimeout(() => setCurrentView("account"), 0);
      return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center animate-in fade-in zoom-in duration-300">
          <Shield className="w-12 h-12 text-rose-500 mb-4 opacity-80" />
          <h2 className="text-xl font-bold text-slate-800 dark:text-slate-200 mb-2">Acesso Restrito</h2>
          <p className="text-slate-500 dark:text-slate-400">Não tem permissões para aceder a esta área.</p>
        </div>
      );
    }

    const content = (() => {
      switch (currentView) {
        case "dashboard": return <WooCommerceDashboard />;
        case "products": return <WooCommerceProducts />;
        case "gallery": return <WooCommerceGallery />;
        case "brands": return <WooCommerceBrands />;
        case "categories": return <WooCommerceCategories />;
        case "orders": return <WooCommerceOrders />;
        case "customers": return <WooCommerceCustomers />;
        case "stock": return <WooCommerceStock />;
        case "loyalty": return <WooCommerceLoyalty />;
        case "pos_products": return <PosTerminal storeId={activeStoreId} defaultTab="pos_products" />;
        case "pos_customers": return <PosTerminal storeId={activeStoreId} defaultTab="pos_customers" />;
        case "pos_scanner": return <PosTerminal storeId={activeStoreId} defaultTab="pos_scanner" />;
        case "leads": return <WooCommerceLeads setCurrentView={setCurrentView} />;
        case "logs": return <LogsTab />;
        case "notificacoes": return isMaster ? <Notificacoes /> : <WooCommerceDashboard />;
        case "master_plans": return isMaster ? <MasterPlans /> : <WooCommerceDashboard />;
        case "master_subscriptions": return isMaster ? <MasterSubscriptions /> : <WooCommerceDashboard />;
        case "master_finance": return isMaster ? <MasterFinancial /> : <WooCommerceDashboard />;
        case "manager_subscription": return <ManagerSubscription storeId={activeStoreId} />;
        case "settings": return <WooCommerceSettings />;
        case "account": return <WooCommerceProfile />;
        default: return <WooCommerceDashboard />;
      }
    })();

    return (
      <Suspense fallback={
        <div className="flex h-[50vh] items-center justify-center">
          <Loader2 className="w-8 h-8 text-brand animate-spin" />
        </div>
      }>
        {content}
      </Suspense>
    );
  };

  const UserAvatar = ({ className = "h-8 w-8" }: { className?: string }) => (
    <Avatar className={className}>
      <AvatarImage src={userAvatar || image_7a56548a0dbf182ef28c570bcae1ce3c84f6df58} className="object-cover" />
      <AvatarFallback>{userName.substring(0, 2).toUpperCase()}</AvatarFallback>
    </Avatar>
  );

  // Public storefront for native stores: guests browse the catalog (default
  // free-plan template) and are asked to sign in / register only when an
  // account-gated feature is used (checkout, orders, loyalty, profile).
  if (showGuestStorefront && !isInitialSyncing) {
    return (
      <Suspense fallback={
        <div className="min-h-screen flex items-center justify-center bg-black text-white">
          <Loader2 className="w-8 h-8 text-brand animate-spin" />
        </div>
      }>
        <ClientLayout
          isGuest={!clientAuthenticated}
          onRequireLogin={() => setGuestWantsLogin(true)}
          onLogout={handleLogout}
          activeStoreId={guestStore?.id || activeStoreId}
          activeStoreConfig={guestStoreConfig}
        />
      </Suspense>
    );
  }

  if (showLogin && !isInitialSyncing) {
    if (!isWhiteLabelUrl && (window.location.pathname === '/' || window.location.pathname === '/pricing')) {
      return (
        <Suspense fallback={
          <div className="flex h-screen items-center justify-center">
            <Loader2 className="w-8 h-8 text-brand animate-spin" />
          </div>
        }>
          <PricingLandingPage />
        </Suspense>
      );
    }

    const isClient = loginMode === 'client';
    const storeByUrl = multiStore.find(s => normUrl(s.config?.customUrl) === urlStoreSlug);
    // Only use store colors if we're on a real white-label URL, not the master root
    const hasWhiteLabel = isWhiteLabelUrl && (brandConfig || storeByUrl);
    const storeBrandColor = hasWhiteLabel
      ? (brandConfig?.brand_color || storeByUrl?.config?.themeColor || '#10B981')
      : '#0F172A'; // LojaPilot master default
    const loginLogo = hasWhiteLabel
      ? (brandConfig?.logo_url || storeByUrl?.config?.logoUrl)
      : (isDarkMode ? logoFullLight : image_logoDark); // LojaPilot logo on root
    // Logo/back link target: landing page on the master host; the store's own
    // storefront on white-label logins (path slug, subdomain or custom domain).
    const loginHomeSlug = urlStoreSlug || normUrl(loginStore?.config?.customUrl);
    const loginHomeHref =
      loginStore?.config?.customDomain?.toLowerCase() === window.location.hostname.toLowerCase()
        ? '/'
        : (loginHomeSlug ? `/loja/${loginHomeSlug}` : '/');

    return (
      <>
        <div className={`min-h-screen flex items-center justify-center p-4 overflow-hidden relative transition-colors duration-500 ${isClient ? '' : 'bg-slate-50 dark:bg-black'}`}
          style={isClient ? { background: `radial-gradient(circle at center, ${storeBrandColor}15 0%, rgba(0,0,0,1) 100%)`, backgroundColor: '#000' } : {}}
        >
          <div className="absolute inset-0 bg-brand/10 blur-[120px] pointer-events-none rounded-full w-[50vw] h-[50vw] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />

          <div className="w-full max-w-[400px] flex flex-col items-center relative z-10">
          <Card className="w-full shadow-2xl border border-slate-200 dark:border-slate-800/60 bg-white/90 dark:bg-[#111111]/90 backdrop-blur-xl rounded-2xl flex flex-col justify-center relative z-10">
            <CardHeader className="text-center space-y-4 pt-8 pb-4">
              <div className="mx-auto flex justify-center">
                <a href={loginHomeHref} aria-label="Voltar à Homepage" className="inline-block transition-opacity hover:opacity-80">
                  <img src={loginLogo || image_logoDark} alt="Manager" className="w-48 h-auto object-contain" />
                </a>
              </div>

              {/* Pill Tabs for Role Selection */}
              {isWhiteLabelUrl ? (
                <div className="flex items-center justify-center pt-2">
                  <div className="bg-slate-100 dark:bg-slate-900/80 p-1 rounded-full flex items-center border border-slate-200 dark:border-slate-800">
                    <button
                      type="button"
                      onClick={() => setLoginMode('staff')}
                      className={`px-4 py-1.5 text-xs font-semibold rounded-full transition-all duration-300 ${!isClient ? 'bg-white dark:bg-slate-800 text-slate-900 dark:text-white shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300'}`}
                    >
                      Acesso Staff
                    </button>
                    {clientLoginEnabled && (
                      <button
                        type="button"
                        onClick={() => setLoginMode('client')}
                        className={`px-4 py-1.5 text-xs font-semibold rounded-full transition-all duration-300 ${isClient ? 'bg-white dark:bg-slate-800 text-slate-900 dark:text-white shadow-sm' : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-300'}`}
                      >
                        Sou Cliente
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <div className="flex items-center justify-center pt-2">
                  <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-700 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-200">
                    Acesso Staff
                  </div>
                </div>
              )}

              <div className="space-y-1.5">
                <p className="text-[11px] font-medium tracking-widest text-slate-500 dark:text-slate-400 uppercase flex flex-col items-center justify-center gap-1">
                  {hasWhiteLabel ? <span className="font-bold text-slate-800 dark:text-slate-200">{storeName}</span> : null}
                  <span className="flex items-center gap-2 mt-1">
                    {hasClientLoginTarget && isClient ? 'Plataforma de Cliente' : 'Plataforma Interna'} <span className="w-1 h-1 rounded-full bg-slate-400 dark:bg-slate-600"></span> Acesso Restrito
                  </span>
                </p>
              </div>
            </CardHeader>

            <div className="px-8">
              <div className="w-full h-px bg-slate-200 dark:bg-slate-800/60 mb-6" />
            </div>

            <form onSubmit={handleLogin} className="w-full px-8">
              <CardContent className="space-y-5 px-0 pb-6">
                {isClient && isNativeGuestStore && (
                  <div className="grid grid-cols-2 gap-1 p-1 rounded-lg bg-slate-100 dark:bg-slate-800">
                    <button
                      type="button"
                      onClick={() => setIsRegistering(false)}
                      className={`h-9 rounded-md text-sm font-semibold transition-all ${!isRegistering ? 'bg-white dark:bg-slate-950 shadow text-slate-900 dark:text-white' : 'text-slate-500 dark:text-slate-400'}`}
                    >
                      Entrar
                    </button>
                    <button
                      type="button"
                      onClick={() => setIsRegistering(true)}
                      className={`h-9 rounded-md text-sm font-semibold transition-all ${isRegistering ? 'bg-white dark:bg-slate-950 shadow text-slate-900 dark:text-white' : 'text-slate-500 dark:text-slate-400'}`}
                    >
                      Criar Conta
                    </button>
                  </div>
                )}
                {isClient && isRegistering && (
                  <div className="space-y-2">
                    <Label htmlFor="register-name" className="text-[10px] font-bold tracking-wider text-slate-600 dark:text-slate-500 uppercase">Nome</Label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <User className="h-4 w-4 text-slate-400 dark:text-slate-500" />
                      </div>
                      <Input
                        id="register-name"
                        required
                        className="bg-white dark:bg-[#0a0a0a] border-slate-200 dark:border-slate-800/80 text-slate-900 dark:text-white h-11 pl-10 focus-visible:ring-1 focus-visible:ring-brand focus-visible:border-brand transition-all rounded-lg text-sm"
                        value={registerName}
                        onChange={e => setRegisterName(e.target.value)}
                        placeholder="O teu nome"
                      />
                    </div>
                  </div>
                )}
                <div className="space-y-2">
                  <Label htmlFor="login-username" className="text-[10px] font-bold tracking-wider text-slate-600 dark:text-slate-500 uppercase">Email / Username</Label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Mail className="h-4 w-4 text-slate-400 dark:text-slate-500" />
                    </div>
                    <Input
                      id="login-username"
                      required
                      className="bg-white dark:bg-[#0a0a0a] border-slate-200 dark:border-slate-800/80 text-slate-900 dark:text-white h-11 pl-10 focus-visible:ring-1 focus-visible:ring-brand focus-visible:border-brand transition-all rounded-lg text-sm"
                      value={loginData.username}
                      onChange={e => setLoginData({ ...loginData, username: e.target.value })}
                      placeholder="email ou username"
                    />
                  </div>
                </div>
                <div className="space-y-2">
                  <Label htmlFor="login-password" className="text-[10px] font-bold tracking-wider text-slate-600 dark:text-slate-500 uppercase">Password</Label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Lock className="h-4 w-4 text-slate-400 dark:text-slate-500" />
                    </div>
                    <Input
                      id="login-password"
                      type={showPassword ? "text" : "password"}
                      required
                      className="bg-white dark:bg-[#0a0a0a] border-slate-200 dark:border-slate-800/80 text-slate-900 dark:text-white h-11 pl-10 pr-10 focus-visible:ring-1 focus-visible:ring-brand focus-visible:border-brand transition-all rounded-lg text-sm"
                      value={loginData.password}
                      onChange={e => setLoginData({ ...loginData, password: e.target.value })}
                      placeholder="••••••••"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 transition-colors"
                    >
                      {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                    </button>
                  </div>
                </div>
                <label className="flex items-center gap-2 cursor-pointer select-none pt-1">
                  <input
                    type="checkbox"
                    checked={rememberSession}
                    onChange={e => setRememberSession(e.target.checked)}
                    className="w-4 h-4 rounded border-slate-300 dark:border-slate-700 accent-emerald-600"
                  />
                  <span className="text-sm text-slate-600 dark:text-slate-400">Manter sessão iniciada</span>
                </label>
              </CardContent>

              <CardFooter className="px-0 pb-8 flex-col gap-6">
                <Button
                  type="submit"
                  disabled={isLoggingIn}
                  className="w-full hover:brightness-90 text-white transition-all h-11 text-sm font-semibold rounded-lg flex items-center justify-center gap-2 group border-none"
                  style={{ backgroundColor: storeBrandColor }}
                >
                  {isLoggingIn ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" /> {isRegistering ? 'A Criar...' : 'A Entrar...'}
                    </>
                  ) : (
                    <>
                      {isRegistering ? 'Criar Conta' : 'Entrar'} <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </>
                  )}
                </Button>



                {!isWhiteLabelUrl && (
                  <p className="text-center text-xs text-slate-500">
                    Ainda não tem conta?{' '}
                    <a href="/signup" className="font-semibold text-emerald-600 hover:underline">
                      Criar conta LojaPilot
                    </a>
                  </p>
                )}

                <div className="flex items-center justify-center gap-2 text-slate-500">
                  <div className="text-[10px] flex items-center gap-1.5 text-center leading-tight">
                    <span className="w-3 h-3 rounded-sm border border-slate-600 flex items-center justify-center bg-[#0a0a0a]">
                      <Shield className="w-2 h-2" />
                    </span>
                    Acesso exclusivo para utilizadores<br />autorizados
                  </div>
                </div>
              </CardFooter>
            </form>
          </Card>
          <a
            href={loginHomeHref}
            className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Voltar à Homepage
          </a>
          </div>
        </div>
        <Toaster richColors position="top-right" theme={isDarkMode ? 'dark' : 'light'} />
      </>
    );
  }

  if (isInitialSyncing) {
    return (
      <>
        <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-black overflow-hidden relative text-white">
          <div className="absolute inset-0 bg-brand/10 blur-[120px] pointer-events-none rounded-full w-[50vw] h-[50vw] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
          <RefreshCw className="w-12 h-12 text-brand animate-spin mb-6" />
          <h2 className="text-2xl font-bold tracking-widest text-white font-['Poppins'] mb-2">A SINCRONIZAR</h2>
          <p className="text-sm text-slate-400 text-center max-w-xs font-['Inter'] leading-relaxed">
            A otimizar a sua cache local.<br />A carregar produtos, encomendas e definições da sua loja.
          </p>
          {/* Emergency exit — aparece só se a sync demorar mais de 15s */}
          {showSyncEscape && (
            <button
              onClick={() => { setIsInitialSyncing(false); setShowLogin(false); SyncService.isSyncing = false; }}
              className="mt-8 text-xs text-slate-600 hover:text-slate-400 underline transition-colors animate-in fade-in duration-500"
            >
              Ignorar e entrar na aplicação
            </button>
          )}
        </div>
        <Toaster richColors position="top-right" theme={isDarkMode ? 'dark' : 'light'} />
      </>
    );
  }

  const availableStores = multiStore.filter(s => {
    if (localStorage.getItem('is_master_admin') === 'true') return true;
    const allowed = JSON.parse(localStorage.getItem('allowed_stores') || "[]");
    return allowed.length === 0 || allowed.includes(s.id);
  });

  const showStoreSelectorInHeader = isMasterAdmin; // Only Master Admin can interact with more than one store

  if (loginMode === 'client' && clientAuthenticated) {
    return (
      <Suspense fallback={
        <div className="min-h-screen flex items-center justify-center bg-black text-white">
          <Loader2 className="w-8 h-8 text-brand animate-spin" />
        </div>
      }>
        <ClientLayout
          onLogout={handleLogout}
          activeStoreId={activeStoreId}
          activeStoreConfig={activeStoreConfig}
        />
      </Suspense>
    );
  }

  return (
    <div className="flex min-h-screen bg-slate-50/50 dark:bg-slate-950 pb-16 lg:pb-0 transition-colors duration-300 overflow-x-hidden">


      {/* PWA Install Invite Overlay */}
      <AnimatePresence>
        {showPWAInvite && (
          <div className="fixed inset-0 z-[100] flex items-end justify-center p-4 bg-black/60 backdrop-blur-sm lg:hidden">
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              className="bg-white dark:bg-slate-900 w-full max-w-sm rounded-2xl shadow-2xl overflow-hidden border border-slate-200 dark:border-slate-800"
            >
              <div className="p-6 flex flex-col items-center text-center space-y-4">
                <div className="relative">
                  <img
                    src="/brand/lojapilot-app-icon.png"
                    alt="LojaPilot App"
                    className="w-20 h-20 rounded-2xl shadow-lg border-2 border-white dark:border-slate-800"
                  />
                  <div className="absolute -bottom-2 -right-2 bg-brand text-white p-1.5 rounded-full shadow-lg">
                    <Smartphone className="w-4 h-4" />
                  </div>
                </div>

                <div className="space-y-2">
                  <h3 className="text-xl font-bold dark:text-white">Instalar a App LojaPilot</h3>
                  <p className="text-sm text-slate-500 dark:text-slate-400">
                    Adicione o LojaPilot ao ecrã principal para uma experiência mais rápida e acesso offline.
                  </p>
                </div>

                <div className="w-full space-y-3 pt-2">
                  <div className="flex items-center justify-center gap-4 text-xs font-medium text-slate-600 dark:text-slate-400 bg-slate-50 dark:bg-slate-800/50 py-3 rounded-xl">
                    <div className="flex flex-col items-center gap-1">
                      <div className="p-2 bg-white dark:bg-slate-800 rounded-lg border dark:border-slate-700">
                        <Share className="w-4 h-4 text-blue-500" />
                      </div>
                      <span>Partilhar</span>
                    </div>
                    <div className="text-slate-300">→</div>
                    <div className="flex flex-col items-center gap-1">
                      <div className="p-2 bg-white dark:bg-slate-800 rounded-lg border dark:border-slate-700">
                        <Download className="w-4 h-4 text-brand" />
                      </div>
                      <span>Ecrã Principal</span>
                    </div>
                  </div>

                  <div className="flex gap-3">
                    <Button
                      variant="outline"
                      className="flex-1 dark:border-slate-700 dark:text-slate-300"
                      onClick={() => {
                        setShowPWAInvite(false);
                        sessionStorage.setItem('pwa_invite_dismissed', 'true');
                      }}
                    >
                      Mais Tarde
                    </Button>
                    <Button
                      className="flex-1 bg-brand hover:brightness-90 text-white"
                      onClick={() => {
                        toast.info("Clique em 'Partilhar' e depois em 'Adicionar ao Ecrã Principal'");
                      }}
                    >
                      Instalar
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      <aside className="hidden lg:flex w-[260px] flex-col border-r border-slate-200 dark:border-slate-800/60 bg-white/50 dark:bg-[#09090b]/50 backdrop-blur-xl">
        <div className="flex h-24 items-center px-6 border-b border-slate-200 dark:border-slate-800/60">
          <div className="flex flex-col min-w-0">
            <img src={(brandConfig?.logo_url) || ((isWhiteLabelUrl && activeStoreConfig?.logoUrl) ? activeStoreConfig.logoUrl : (isDarkMode ? logoFullLight : logoFullDark))} alt={activeStoreConfig?.name || "LojaPilot"} className="h-14 py-2 object-contain self-start" style={{ filter: brandConfig?.brand_color ? `drop-shadow(0 0 10px ${brandConfig.brand_color}50)` : 'none' }} />
            {(() => {
              const storeLabel = multiStore.find(s => s.id === activeStoreId)?.name || activeStoreConfig?.name || normUrl(activeStoreConfig?.customUrl);
              const typeTag = connTypeTag(activeStoreConfig?.connectionType);
              return storeLabel ? (
                <span className="flex items-center gap-1.5 -mt-1 truncate">
                  <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400 dark:text-slate-500 truncate">{storeLabel}</span>
                  {typeTag && (
                    <span className={`text-[8px] font-bold uppercase tracking-wider px-1 py-px rounded shrink-0 ${activeStoreConfig?.connectionType === 'native' ? 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400' : 'bg-slate-200/80 text-slate-500 dark:bg-slate-800 dark:text-slate-400'}`}>{typeTag}</span>
                  )}
                </span>
              ) : null;
            })()}
          </div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setCurrentView(item.id as View)}
              className={`flex items-center gap-3 w-full px-3 py-2.5 text-sm font-medium rounded-lg transition-colors ${currentView === item.id
                ? "bg-brand text-white"
                : "text-muted-foreground dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-foreground dark:hover:text-white"
                }`}
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </button>
          ))}
        </nav>
        <div className="p-4 border-t dark:border-slate-800">
          <button
            onClick={() => setCurrentView("account")}
            className={`flex items-center gap-3 w-full px-3 py-2 text-sm font-medium rounded-lg transition-colors ${currentView === "account"
              ? "bg-slate-100 dark:bg-slate-800 text-foreground dark:text-white"
              : "text-muted-foreground dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-foreground dark:hover:text-white"
              }`}
          >
            <UserAvatar className="h-6 w-6" />
            <div className="flex-1 text-left truncate">
              <p className="font-semibold text-slate-900 dark:text-white leading-tight">{userName}</p>
              <p className="text-[10px] text-slate-500 dark:text-slate-500">
                {localStorage.getItem('is_master_admin') === 'true'
                  ? 'Administrador Principal'
                  : (appUserRole === 'pos' ? 'POS / Balcão' : 'Gestor de Loja')}
              </p>
              <div className="text-[9px] opacity-50 dark:text-slate-400">@{localStorage.getItem('app_username') || 'admin'}</div>
            </div>
          </button>
          <Button
            variant="ghost"
            size="sm"
            className="w-full mt-2 text-rose-600 dark:text-rose-400 justify-start h-8 px-3 hover:bg-rose-50 dark:hover:bg-rose-950/30"
            onClick={handleLogout}
          >
            <LogOut className="w-3 h-3 mr-2" /> Terminar Sessão
          </Button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 flex items-center justify-between px-4 lg:px-6 bg-white dark:bg-black border-b dark:border-slate-800 sticky top-0 z-10 gap-4 transition-colors">
          <div className="flex items-center gap-3 shrink-0">
            {/* Mobile Logo on Left */}
            <img
              src={(brandConfig?.logo_url) || ((isWhiteLabelUrl && activeStoreConfig?.logoUrl) ? activeStoreConfig.logoUrl : mobileLogo)}
              alt={activeStoreConfig?.name || "LojaPilot"}
              className="h-12 w-12 object-contain lg:hidden"
            />
          </div>

          <div className="flex-1 flex items-center gap-4">
            {showStoreSelectorInHeader && (
              <div className="hidden lg:block">
                <Select value={activeStoreId} onValueChange={handleSwitchStore}>
                  <SelectTrigger className="w-[200px] h-9 dark:bg-slate-950 dark:border-slate-800 dark:text-white hover:text-brand dark:hover:text-brand">
                    <div className="flex items-center gap-2 truncate">
                      <Globe className="w-3 h-3 text-brand" />
                      <SelectValue placeholder="Loja" />
                    </div>
                  </SelectTrigger>
                  <SelectContent className="dark:bg-slate-900 dark:border-slate-800">
                    {availableStores.map(s => (
                      <SelectItem key={s.id} value={s.id} className="dark:focus:bg-slate-800 dark:text-slate-300">
                        <div className="flex items-center justify-between gap-3 w-full">
                          <span className="truncate">{s.name}</span>
                          {connTypeTag(s.config?.connectionType) && (
                            <span className="text-[9px] uppercase font-bold text-slate-400 shrink-0">{connTypeTag(s.config?.connectionType)}</span>
                          )}
                        </div>
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            )}
          </div>

          <div className="flex items-center gap-1 lg:gap-2 shrink-0">
            {isOffline && (
              <Badge variant="outline" className="hidden sm:flex bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 border-amber-200 dark:border-amber-900/50 text-[10px] h-6 px-2 gap-1.5 animate-pulse">
                <WifiOff className="w-3 h-3" /> Offline
              </Badge>
            )}

            {/* Mobile User Icon */}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setCurrentView("account")}
              className="dark:text-white hover:text-brand dark:hover:text-brand lg:hidden"
            >
              <User className="w-5 h-5" />
            </Button>

            <Button variant="ghost" size="icon" onClick={toggleDarkMode} className="dark:text-white hover:text-brand dark:hover:text-brand">
              {isDarkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
            </Button>

            <Button variant="ghost" size="icon" onClick={handleLogout} className="dark:text-white hover:text-red-500 dark:hover:text-red-400" title="Terminar Sessão">
              <LogOut className="w-5 h-5" />
            </Button>

            {/* Mobile Toggle Menu on Right */}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsMobileMenuOpen(true)}
              className="dark:text-white hover:text-brand dark:hover:text-brand lg:hidden"
            >
              <Menu className="w-5 h-5" />
            </Button>

            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="p-0 hover:bg-transparent hidden lg:flex">
                  <UserAvatar className="h-8 w-8" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56 dark:bg-slate-900 dark:border-slate-800">
                <DropdownMenuLabel className="dark:text-slate-200">Conta</DropdownMenuLabel>
                <DropdownMenuSeparator className="dark:bg-slate-800" />
                <DropdownMenuItem onClick={() => setCurrentView("account")} className="dark:text-slate-300 dark:focus:bg-slate-800">
                  <User className="w-4 h-4 mr-2" /> Perfil
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => setCurrentView("settings")} className="dark:text-slate-300 dark:focus:bg-slate-800">
                  <Settings className="w-4 h-4 mr-2" /> Definições
                </DropdownMenuItem>
                <DropdownMenuSeparator className="dark:bg-slate-800" />
                <DropdownMenuItem className="text-rose-600 dark:text-rose-400 dark:focus:bg-slate-800" onClick={handleLogout}>
                  <LogOut className="w-4 h-4 mr-2" /> Terminar Sessão
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </header>

        <main className="flex-1 overflow-hidden dark:bg-slate-950 transition-colors">
          <PullToRefresh onRefresh={handleGlobalRefresh}>
            <AnimatePresence mode="wait">
              <motion.div
                key={currentView}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.2 }}
                className="w-full h-full min-h-0 min-w-0 max-w-[1024px] mx-auto pb-24"
              >
                {renderView()}
              </motion.div>
            </AnimatePresence>
          </PullToRefresh>
        </main>
      </div>

      <div className="lg:hidden fixed bottom-0 left-0 right-0 h-16 bg-brand border-t border-[#ffffff20] flex items-center justify-around z-40 pb-[env(safe-area-inset-bottom)] box-content">
        {mobileFooterItems.map((item) => {
          const isActive = currentView === item.id;
          return (
            <button
              key={item.id}
              onClick={() => {
                setCurrentView(item.id as View);
                if (item.id === 'orders') setPendingOrdersCount(0);
              }}
              className={`flex flex-col items-center justify-center w-full h-full transition-all relative min-h-[44px] active:scale-95 ${isActive ? "bg-white text-brand rounded-none" : "text-white/80 hover:text-white"
                }`}
            >
              <item.icon className="w-6 h-6" />
              {item.id === 'orders' && pendingOrdersCount > 0 && !isActive && (
                <span className="absolute top-2 right-1/2 translate-x-3 flex h-4 w-4 items-center justify-center rounded-full bg-rose-500 text-[10px] font-bold text-white border-2 border-brand animate-in zoom-in">
                  {pendingOrdersCount}
                </span>
              )}
            </button>
          );
        })}
      </div>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsMobileMenuOpen(false)}
              className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            />
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 200 }}
              className="fixed inset-y-0 left-0 w-72 bg-white dark:bg-slate-900 z-50 lg:hidden flex flex-col shadow-xl"
            >
              <div className="h-24 flex items-center justify-between px-6 border-b dark:border-slate-800">
                <img src={(brandConfig?.logo_url) || ((isWhiteLabelUrl && activeStoreConfig?.logoUrl) ? activeStoreConfig.logoUrl : (isDarkMode ? logoFullLight : logoFullDark))} alt={activeStoreConfig?.name || "LojaPilot"} className="h-16 py-2 object-contain max-h-20 w-auto" />
                <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(false)} className="dark:text-slate-300">
                  <X className="w-5 h-5" />
                </Button>
              </div>
              <nav className="flex-1 p-4 space-y-1">
                {navItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => {
                      setCurrentView(item.id as View);
                      setIsMobileMenuOpen(false);
                    }}
                    className={`flex items-center gap-3 w-full px-4 py-3 text-sm font-medium rounded-lg transition-colors ${currentView === item.id
                      ? "bg-brand text-white"
                      : "text-muted-foreground dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800"
                      }`}
                  >
                    <item.icon className="w-5 h-5" />
                    {item.label}
                  </button>
                ))}

                {isMasterAdmin && (
                  <div className="pt-4 mt-2 border-t dark:border-slate-800 px-2">
                    <Label className="text-[10px] font-bold uppercase text-slate-500 mb-2 block">Seleção de Loja</Label>
                    <Select value={activeStoreId} onValueChange={(val) => { handleSwitchStore(val); setIsMobileMenuOpen(false); }}>
                      <SelectTrigger className="w-full h-10 dark:bg-slate-950 dark:border-slate-800 dark:text-slate-200">
                        <div className="flex items-center gap-2 truncate text-sm">
                          <Globe className="w-4 h-4 text-brand" />
                          <SelectValue placeholder="Selecionar Loja" />
                        </div>
                      </SelectTrigger>
                      <SelectContent className="dark:bg-slate-900 dark:border-slate-800">
                        {availableStores.map(s => (
                          <SelectItem key={s.id} value={s.id} className="dark:focus:bg-slate-800 dark:text-slate-300">
                            <div className="flex items-center justify-between gap-3 w-full">
                              <span className="truncate">{s.name}</span>
                              {connTypeTag(s.config?.connectionType) && (
                                <span className="text-[9px] uppercase font-bold text-slate-400 shrink-0">{connTypeTag(s.config?.connectionType)}</span>
                              )}
                            </div>
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                )}
              </nav>
              <div className="p-4 border-t dark:border-slate-800 bg-slate-50 dark:bg-slate-900 mb-16 lg:mb-0">
                <div className="flex items-center gap-3 px-2 mb-3">
                  <UserAvatar className="h-8 w-8 shrink-0" />
                  <div className="flex-1 truncate cursor-pointer" onClick={() => { setCurrentView("account"); setIsMobileMenuOpen(false); }}>
                    <div className="font-semibold text-sm dark:text-slate-200">{userName}</div>
                    <div className="text-xs text-muted-foreground dark:text-slate-400">
                      {localStorage.getItem('is_master_admin') === 'true'
                        ? 'Administrador Principal'
                        : (appUserRole === 'pos' ? 'POS / Balcão' : 'Gestor de Loja')}
                    </div>
                  </div>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  className="w-full text-rose-600 dark:text-rose-400 border-rose-200 dark:border-rose-900/50 hover:bg-rose-50 dark:hover:bg-rose-950/30 justify-center gap-2"
                  onClick={handleLogout}
                >
                  <LogOut className="w-4 h-4" /> Terminar Sessão
                </Button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
      <Toaster richColors position="top-right" theme={isDarkMode ? 'dark' : 'light'} />
    </div>
  );
}